{
  "LIST_FILTER_ROW": {
  	"aria_label": "filters",
  	"status": "status",
  	"open_amount": "open balance",
  	"more": "+{{count}} more",
  	"search_tag": "search tag…",
  	"or_hint": "any of these tags",
  	"clear_all": "clear all",
  	"clear_filters": "clear filters",
  	"no_results_filters": "no bookings match these filters.",
  	"clear_chip": "clear {{name}}",
  	"bookings_total": "{{count}} bookings",
  	"bookings_total_one": "{{count}} booking",
  	"flights_total": "{{count}} flights",
  	"flights_total_one": "{{count}} flight",
  	"search_hint": "Press Enter to search · date = yyyy-mm-dd",
  	"more_actions": "more actions",
  	"period": "period",
  	"period_all": "all",
  	"period_today": "today",
  	"period_this_week": "this week",
  	"period_this_month": "this month",
  	"period_next_month": "next month",
  	"period_custom": "custom…",
  	"free_spots": "free spots",
  	"free_spots_all": "all",
  	"free_spots_min": "at least {{n}}",
  	"free_spots_overbooked": "overbooked"
  },
  "SEARCH_ELSEWHERE": {
    "none_in_filter": "no results in \"{{filter}}\" for \"{{search}}\".",
    "found_in": "found in:",
    "also_found_in": "also found in"
  },
  "LOGIN": {
    "email_me_a_login_link": "email me a login link",
    "login_link_sent": "a login link was sent",
    "signed_in_elsewhere_title": "you're signed in",
    "signed_in_elsewhere": "you are signed in via the link in another tab — you can close this tab",
    "continue_here": "continue here",
    "completing_signin": "signing you in…",
    "confirm_email_for_link": "please confirm your email address to finish signing in",
    "continue": "continue",
    "login_link_invalid": "this login link is no longer valid. please request a new one.",
    "request_new_link": "request a new link"
  },
  "MONTY": {
      "requested_prefix": "customer asks",
      "requested_MATCH": "{{date}} → flight {{flight}} ({{free}} free)",
      "requested_CURRENT": "{{date}} → already on this flight ({{flight}})",
      "requested_FULL": "{{date}} → full in the zone",
      "requested_NOT_PLANNED": "{{date}} → no flight planned yet in the zone",
      "requested_PRIVATE_ONLY": "{{date}} → only a private flight ({{flight}})",
      "requested_OUT_OF_VALIDITY": "{{date}} → after the booking's validity",
      "requested_PAST": "{{date}} → in the past",
      "date_conflict": "weekday and date did not match, the date was used",
      "needs_review": "check the text: {{items}} does not come from the flight data",
      "tag_P": "planning",
      "tag_Q": "question",
      "tag_W": "weather",
      "tag_C": "complaint / sensitive",
      "tag_N": "no action needed",
      "action_accepted_line": "action executed via Monty",
    "accept": "accept",
      "dismiss": "dismiss action",
      "action_repick": "click to pick another flight",
      "action_CONFIRM_ON_FLIGHT": "confirm booking on",
      "action_MOVE_TO_FLIGHT": "move booking to",
      "action_REMOVE_FROM_FLIGHT": "remove booking from",
      "failure_FLIGHT_FULL": "flight is full or closed — pick another flight",
      "failure_FLIGHT_CANCELLED": "flight was cancelled — pick another flight",
      "failure_PROPOSAL_NOT_OPEN": "proposal is no longer open",
      "proposal_strip": "Monty's proposal — adjust or send",
      "proposal_clear": "remove proposal",
      "proposal_insert": "proposal available — click to insert",
      "settings_panel_title": "Monty - your AI assistant",
      "settings_key_title": "Anthropic API key",
      "settings_key_note": "Monty runs on your own Anthropic account: enter your API key to activate. Costs are billed to your own account.",
      "settings_key_label": "API key",
      "settings_key_save": "save & validate",
      "settings_key_replace": "replace",
      "settings_key_remove": "remove",
      "status_active": "active",
      "status_no_credits": "no credits left — Monty is paused",
      "status_no_credits_note": "new messages are not tagged for now; Monty resumes automatically once credits are available",
      "status_key_invalid": "key invalid — Monty is inactive",
      "status_off": "not configured",
      "settings_usage_title": "usage & costs",
      "settings_usage_note": "estimate based on token usage and list prices; billing runs through your own Anthropic account",
      "usage_month": "month",
      "usage_classifications": "classifications",
      "usage_proposals": "proposals",
      "usage_cost": "estimated cost",
      "usage_learn_runs": "learning runs",
      "instructions_title": "instructions per category",
      "instructions_note": "describe how you typically answer each kind of message (tone, standard info, policies) — Monty follows this when drafting replies",
      "instructions_manual_label": "your instructions",
      "instructions_learned_title": "proposal from history — review and adjust",
      "instructions_learned_from": "based on {{count}} answered messages from the last {{months}} months",
      "instructions_learned_note": "Monty already uses this proposal together with your own instructions. Adopt it into your instructions to make it permanent — otherwise the next learning run replaces it.",
      "instructions_adopt_draft": "adopt into my instructions",
      "instructions_discard_draft": "discard proposal",
      "instructions_save": "save",
      "learn_title": "learn from history",
      "learn_note": "Monty tags your past conversations and distills per category how you typically reply; the result is added above as an editable proposal",
      "learn_button": "learn from history",
      "learn_month": "month",
      "learn_months": "months",
      "learn_messages": "messages",
      "learn_estimated_cost": "estimated cost",
      "learn_warning": "this run uses the credits of your own Anthropic account",
      "learn_start": "start learning",
      "learn_cancel_dialog": "cancel",
      "learn_no_messages": "no messages in this period",
      "learn_progress": "{{done}} of {{total}} messages processed",
      "learn_phase_TAGGING": "tagging history",
      "learn_phase_DISTILLING": "distilling instructions",
      "learn_state_RUNNING": "learning run in progress",
      "learn_state_COMPLETED": "learning run completed",
      "learn_state_CANCELLED": "learning run cancelled",
      "learn_state_STOPPED_NO_CREDITS": "stopped — no credits left; tags so far are kept",
      "learn_resume": "resume",
      "learn_cancel_run": "cancel run",
      "learn_cost_so_far": "consumed"
  },
  "CHARTS": {
    "last1months": "1m",
    "last3months": "3m",
    "last6months": "6m",
    "last12months": "12m",
    "last24months": "24m"
  },
  "VALIDATIONS": {
    "checkin_edit": "edit",
    "checkin_clear_signoff": "clear sign-off",
    "checkin_clear_signoff_confirm": "Clear the pilot sign-off? The flight will count as not signed off until it is signed again.",
    "checkin_manual_value": "manually set by the pilot during check-in",
    "checkin_signed_off": "the flight is already signed off - clear the sign-off first",
    "checkin_flight_not_found": "flight not found",
    "checkin_invalid_hour": "invalid takeoff time",
    "checkin_invalid_tempTakeoff": "takeoff temperature must be between -40 and 50 °C",
    "checkin_invalid_tempBalloon": "balloon temperature must be between 50 and 150 °C",
    "checkin_invalid_windGl": "ground wind must be between 0 and 60 kt",
    "checkin_invalid_windGlDirection": "wind direction must be between 0 and 360°",
    "checkin_invalid_weatherQnh": "QNH must be between 900 and 1100 hPa",
    "checkin_invalid_plannedFlightTime": "planned flight time must be positive and not exceed the maximum flight time",
    "load_failed": "could not load this data",
    "error": "An unexpected error occured, review your input",
    "minimun_one_adult_or_Child_is_required": "You need minimun one adult or child",
    "error_tenant_does_not_exist": "the operator doesn't exist",
    "not_possible": "this action is not possible",
    "required": "required field",
    "tenant_is_required": "operator is a required field",
    "email_is_required": "email is a required field",
    "wrong_password": "wrong password",
    "check_email": "a password reset link was sent",
    "International_phone_format": "international format required",
    "email": "invalid email address",
    "duplicate_email": "duplicate email address is not allowed",
    "no_integer": "this is not a valid whole number",
    "positive_number": "must be zero or positive",
    "lift_orange_below_red": "the green limit must be at least the orange limit",
    "token_has_expired": "token has expired",
    "wrong_credentials": "wrong credentials",
    "flight_date_in_past": "this flight is in the past",
    "save_or_cancel_updates": "save or cancel your updates first",
    "warning": "warning",
    "capacity_must_be_between_0_and_30": "capacity must be between 0 and 100",
    "validation_errors": "correct first the errors in the form",
    "mismatch_location": "region mismatch",
    "mismatch_availability": "period mismatch",
    "mismatch_start_date": "flight date too soon",
    "mismatch_end_date": "flight date too late",
    "mismatch_type": "flight type mismatch",
    "mismatch_flight": "booked for another flight",
    "missing_function": "This function is expected soon",
    "attachment_not_found": "file not found in storage",
    "invalid_file_only_pdf_jpg_png_max_10MB": "Invalid file: only PDF, JPG and PNG up to 10 MB are accepted.",
    "invalid_file_too_large_max_10MB": "File is too large: the maximum size is 10 MB.",
    "no_category": "no passenger categories found, go first to settings to add 1 or more categories.",
    "no_region": "no region found, go first to regions to add 1 or more regions.",
    "lift_mismatch": "lift calculation is not possible due to missing data",
    "lift_missing_location": "location is missing",
    "lift_missing_balloon_volume": "envelope volume is unknown",
    "lift_missing_balloon_weight": "balloon weight is unknown or incomplete",
    "lift_missing_pilot": "pilot is unknown",
    "lift_missing_pilot_weight": "pilot weight is unknown",
    "lift_missing_temp_takeoff": "take-off temperature is unknown",
    "lift_missing_pressure": "take-off pressure is unknown",
    "mobile_missing_signature": "not all passengers are checked in",
    "mobile_missing_forecast": "no weather forecast available",
    "mobile_documents": "expiry dates",
    "mobile_doc_insurance": "insurance valid till",
    "mobile_doc_airworthiness": "airworthiness valid till",
    "mobile_doc_license": "pilot license valid till",
    "mobile_clear": "clear",
    "mobile_agree": "agree",
    "mobile_self_sign": "sign X",
    "click_to_fly": "click to fly",
    "click_to_fly_all": "confirm all",
    "pax_good_to_fly": "pax ok",
    "lift_good_to_fly": "lift ok",
    "fuel_good_to_fly": "fuel ok",
    "weather_good_to_fly": "weather ok",
    "docs_good_to_fly": "documents ok",
    "pilot_sign_off": "confirm all parameters and sign for approval. Comments on the parameters can be added first.",
    "agree": "agree",
    "redo": "redo",
    "new_version": "new version available",
    "reload_the_app": "do you want to restart Quick Release now?",
    "new_features_available": "{0} new feature(s) available",
    "show_new_features": "show new features",
    "forget_device": "sign out and forget device",
    "bookings_with_open_amount": "bookings with open amount",
    "bookings_to_confirm": "to confirm",
    "bookings_bookmarked": "bookmarks",
    "cylinder_capacity_must_be_between_0_and_200": "capacity must be between 0 and 200",
    "cylinder_weight_must_be_between_0_and_200": "weight must be between 0 and 200",
    "unauthorized": "you are not authorized for this operation",
    "disconnected": "connectivity problem, do you have internet?",
    "possible_duplicates": "we have found a possible duplicate booking (the same contact details were found in another open booking)",
    "possible_duplicates_with_flights": "we have found a possible duplicate booking an another flight",
    "duplicate_flight": "balloon is already planned",
    "duplicate_pilot": "pilot is already planned",
    "crew_ready_changed_warning": "The crew has already been notified. Please inform them about the changes."
  },
  "HINTS": {
    "add_country_code": "add country code +32...",
    "no_contact_selected": "Select a contact",
    "message_filter": "filter on/off",
    "role_can_only_be_set_after_creation": "the role can only be set after creation",
    "please_wait": "please wait"
  },
  "SKEYES": {
    "ballooning_bulletin": "Ballooning Bulletin",
    "load": "Skeyes login",
    "disclaimer": "The ballooning bulletin is a service of Skeyes",
    "instructions": "Enter your Skeyes login and password to consult the Ballooning Bulletin. Only pilots with a valid license can consult the Ballooning Bulletin. The data is only used to consult the Ballooning Bulletin and is not stored. Skeyes terms of use apply.",
    "username": "Skeyes Username",
    "password": "Skeyes Password",
    "loaded_by": "loaded by",
    "loading_can_take_up_to_15sec": "loading can take up to 15 seconds",
    "error": "error loading the ballooning bulletin",
    "slot_warning": "this bulletin is probably not valid for this flight"
  },
  "APPLICATION": {
    "domain": "domain",
    "Du": "nederlands (Nederland)",
    "Nl": "nederlands (België)",
    "Fr": "français (french)",
    "En": "english",
    "Es": "español (spanish)",
    "Cs": "cesky (czech)",
    "It": "Italiano (Italian)",
    "De": "Deutsch (German)",
    "Pt": "Português (portuguese)",
    "Lv": "Latviešu (Latvian)",
    "date": "date",
    "name": "name",
    "call_sign": "call sign",
    "capacity": "capacity",
    "flight_count": "flights",
    "sku": "sku",
    "unit_count": "units",
    "unit_cost": "unit price",
    "send_sms": "send sms",
    "receive_sms": "received sms",
    "sms_count": "sms",
    "payments": "payments",
    "running_month": "running month",
    "history_balloons": "history balloons",
    "history_sms": "history sms",
    "total_cost": "price",
    "sorry": "sorry",
    "flights": "flights",
    "calendar": "calendar",
    "vouchers": "vouchers",
    "bookings": "bookings",
    "balloons": "balloons",
    "crew": "crew and pilots",
    "regions": "regions",
    "locations": "locations",
    "reports": "reports",
    "logbooks": "logbooks",
    "admin": "admin",
    "releasenotes": "release notes",
    "subscription": "subscription",
    "log_sms_in": "inbound sms",
    "log_sms_out": "outbound sms",
    "settings": "settings",
    "cylinders": "cylinders",
    "language": "language",
    "sms": "sms",
    "help": "help",
    "search": "search",
    "live_filter_off": "Use the search button to search. If you want more than 25 search results, then live search is disabled",
    "add_booking": "add booking",
    "add_voucher": "add voucher",
    "add_flight": "add flight",
    "privacy_policy": "privacy policy",
    "terms": "terms",
    "sign in to use your Quick Release Account": "sign in to use your Quick Release Account",
    "your username and password didn't match": "your username and password didn't match",
    "please try again": "please try again",
    "username": "username",
    "password": "password",
    "sign_in": "sign in",
    "send_PIN": "send PIN",
    "use_PIN": "use PIN",
    "pin_successfully_sent": "PIN successfully sent",
    "use_password": "use password",
    "send_email": "send email",
    "email": "email",
    "send_email_to": "select addressee",
    "select_template": "select template",
    "sent": "sent",
    "waiting": "sending",
    "error": "sending failed",
    "pin": "PIN",
    "verification_code": "verification code",
    "verification_code_subtitle": "Enter the 6-digit code you received via email",
    "resend_code": "resend code",
    "resend_code_disabled": "resend code in 30 seconds",
    "code_required": "Code is required",
    "code_pattern": "Must be 6 digits",
    "verify_code": "verify code",
    "trust_device": "This device will be trusted for 60 days. In the next 60 days, you will not need a verification code to log in",
    "sign_out": "sign out",
    "save": "save",
    "save_and_back": "save and back",
    "cancel": "cancel",
    "previous": "previous",
    "delete": "delete",
    "refresh": "refresh",
    "new_version_available": "a new version of Quick Release is available",
    "today": "today",
    "classic": "back to old interface",
    "month": "month",
    "week": "week",
    "morning_flights": "morning flights today",
    "evening_flights": "evening flights today",
    "morning_flights_tomorrow": "morning flights tomorrow",
    "yesterday_flights": "evening flights yesterday",
    "action": "action",
    "version": "version",
    "messages": "messages",
    "assign": "assign",
    "assigned": "assigned",
    "assign_to": "assign flight to",
    "close": "close",
    "apps": "resources",
    "more": "more"
  },
  "CALENDAR": {
    "MATRIX": {
      "plan_flight": "plan a flight",
      "flyability_flight_location": "flyability warning for this flight's location",
      "pilot": "pilot",
      "driver_be": "driver (BE)",
      "crew": "crew",
      "occupancy": "occupancy confirmed / added",
      "cancelled": "cancelled",
      "conflict_tooltip": "multiple flights on the same daypart — click to resolve in the day planner",
      "morning": "morning",
      "evening": "evening",
      "weather_anchor": "weather & sun: default location",
      "weather_anchor_tooltip": "day weather and sun times are for the default location; flight cells show their own location's flyability",
      "no_default_location": "set a default location to see day weather and sun times",
      "sunrise_tooltip": "sunrise at the default location",
      "sunset_tooltip": "sunset at the default location",
      "open_bookings": "open bookings",
      "load_more": "load more",
      "already_assigned_tooltip": "already assigned to this flight — dropping it elsewhere moves it, it never duplicates",
      "open": "open",
      "events": "events",
      "seats": "seats",
      "move_overflow_title": "not enough capacity",
      "move_overflow_body": "The target balloon has fewer seats than the passengers on this flight. Move anyway?",
      "flights": "flights",
      "available": "available",
      "no_availability_info": "no availability info for this daypart",
      "edit_hint": "click an info field on a card to edit it in a pop-up — full editing via flight detail",
      "location": "location",
      "pilot_crew": "pilot & crew",
      "weather": "weather",
      "lift": "lift",
      "comment": "comment",
      "edit_in_popup": "edit in pop-up",
      "assign": "— assign",
      "move": "move",
      "flight_detail": "flight detail",
      "drop_bookings_here": "no bookings yet — drop them here",
      "search_placeholder": "search by name, phone or comment…",
      "search_hint": "Enter — searches server-side",
      "no_open_bookings": "no open bookings for this daypart",
      "waiting_list_hint": "drop an assigned booking here to unassign it",
      "back_to_classic": "back to the classic dashboard",
      "previous_week": "previous week",
      "next_week": "next week",
      "this_week": "this week",
      "classic_until": "available until 31 March 2027",
      "try_matrix_banner": "Try the new dashboard with week planning — it becomes the standard on 31 March 2027.",
      "try_matrix": "try it",
      "create": "create",
      "hour_derived": "automatic: sunrise/sunset at the chosen location, incl. your offset",
      "hour": "hour",
      "date": "date",
      "period": "period",
      "balloon": "balloon"
    },
    "waiting_list": "waiting list",
    "no_bookings_yet": "no bookings yet",
    "drag_and_drop_reservations_here_to_add_to_this_flight": "drag and drop bookings here to add to this flight",
    "drag_and_drop_reservations_here_to_remove_from_this_flight": "drap and drop bookings here to remove from the flight",
    "good_job": "good job!",
    "all_bookings_are_added_to_a_flight": "all bookings were added to a flight",
    "you_cannot_drop_bookings_here": "you cannot drop bookings here",
    "show_calendar_crew": "show calendar of crew",
    "set_month": "set month",
    "clear_month": "delete all",
    "plan": "plan",
    "refetch": "refresh",
    "show_all_pilots": "show all pilots",
    "show_all_crew": "show all crew"
  },
  "ACTORS": {
    "COM": "CPL",
    "NCO": "PPL",
    "NOL": "no license",
    "NOA": "no access",
    "OPR": "operator",
    "CRE": "pilot/crew (only assigned flights)",
    "REP": "report viewer",
    "ASS": "Operator assistant (flights & bookings)",
    "MET": "meteo (only flights)",
    "user_role": "user role",
    "name": "name",
    "phone": "phone",
    "email": "email",
    "used_for_login": "used for login",
    "emailNotifications": "email notifications",
    "emails_from_the_system_will_be_send_to_this_address": "emails from the system will be send to this address, not the login address",
    "driver_license": "driver license",
    "driver_license_none": "no license",
    "pilot_license": "pilot license ",
    "ground_crew": "ground crew",
    "language": "language",
    "confirm_message": "are you sure you want to delete?",
    "confirm": "confirm",
    "contacts": "contacts",
    "update": "update",
    "delete": "delete",
    "save": "save",
    "add_contact": "add contact",
    "crew": "crew",
    "pilot": "pilot",
    "add_crew": "add crew",
    "national_license": "national license",
    "part_fcl_license": "PART-FCL license",
    "license_group_A": "group A",
    "license_group_B": "group B",
    "license_group_C": "group C",
    "license_group_D": "group D",
    "license_gas": "gas balloon",
    "license_number": "license number",
    "license_expiry_date": "license / OPC expiry date",
    "license_extra_crew": "license extra crew",
    "ground_crew_training_expiry_date": "ground crew training expiry date",
    "first_aid_expiry_date": "first aid training expiry date",
    "fire_extinguisher_expiry_date": "fire extinguisher training expiry date",
    "medical_expiry_date": "medical expiry date",
    "weight": "weight",
    "warning_not_current": "pilot's validity expires within 30 days, check the expiry dates",
    "error_not_current": "pilot grounded, check the expiry dates",
    "assigned_to_flight": "assigned to flight",
    "your_flight": "your flight",
    "your_flights": "your flights",
    "pilots": "pilots",
    "drivers": "BE-crew"
  },
  "BALLOONS": {
    "upload_photo": "upload photo",
    "name": "name",
    "call_sign": "call sign",
    "capacity": "seats",
    "total_weight": "total weight",
    "balloons": "balloons",
    "confirm_message": "are you sure you want to delete?",
    "confirm": "confirm",
    "update": "update",
    "delete": "delete",
    "save": "save",
    "add_balloon": "add balloon",
    "group": "group",
    "MLM": "MTM (Minimum Landing Mass)",
    "MTOM": "MTOM (Maximum Take-Off Mass)",
    "lift_warning_title": "lift warning zones",
    "lift_warning_explain": "colour of the spare lift per flight: doubtful (orange) from the first value, good (green) from the second — below the orange limit the flight turns red. Blue appears when the flight could land below the MLM.",
    "lift_warning_unconfigured": "not configured — only a negative spare lift shows red",
    "lift_zone_red": "too low",
    "lift_zone_orange": "doubtful",
    "lift_zone_green": "good",
    "lift_orange_from": "doubtful (orange) from",
    "lift_good_from": "good (green) from",
    "min_fuel": "average consumption (Liter per hour)",
    "liter_per_hour": "liter per hour",
    "fuel": "consumption at 20°C and maximum number of passengers",
    "envelope": "envelope",
    "envelope_manufacturer": "envelope manufacturer",
    "envelope_type": "envelope type",
    "envelope_volume": "volume envelope",
    "envelope_weight": "envelope weight",
    "envelope_hours": "envelope hours",
    "envelope_inspection_date": "inspection valid until",
    "balloon_temp": "envelope temperature",
    "burner": "burner",
    "burner_manufacturer": "burner manufacturer",
    "burner_type": "burner type",
    "burner_weight": "burner weight",
    "cylinder_hint": "Save the balloon first and then add cylinders. Make sure you first create the cylinders in the system. The same cylinders can be used on multiple balloons",
    "cylinder": "cylinders",
    "cylinder_manufacturer": "manufacturer",
    "cylinder_volume": "volume",
    "cylinder_count": "number",
    "cylinder_empty_weight": "empty weight",
    "cylinder_full_weight": "full weight",
    "cylinder_total_weight": "total weight",
    "cylinder_number": "number",
    "cylinder_serial": "serial number",
    "basket": "basket",
    "basket_manufacturer": "basket manufacturer",
    "basket_type": "basket type",
    "basket_weight": "basket weight",
    "insurance_company": "insurance company",
    "insurance_due_date": "insurance expiry date",
    "add_cylinder": "add cylinder",
    "error_not_current": "Balloon grounded, update the expiry dates",
    "warning_not_current": "Balloon expires in 30 days, update the expiry dates"
  },
  "VOUCHERS": {
    "status": "status",
    "create_booking": "create booking",
    "available": "available",
    "used": "used",
    "expired": "expired",
    "voucher_type": "type",
    "show_all_types": "show all types",
    "voucher_reference": "reference",
    "issue_date": "issue date",
    "expiry_date": "expiry date",
    "contactName": "contact name",
    "contactPhone": "phone",
    "contactLanguage": "language",
    "contactEmail": "e-mail",
    "contact_city": "city",
    "recipient_info": "details of the person who will receive and use the voucher",
    "buyer_info": "details of the person who purchased the voucher",
    "details_info": "specific information about the voucher itself",
    "buyer": "purchased by",
    "recipient": "recipient",
    "recipientName": "name",
    "recipientPhone": "phone",
    "recipientLanguage": "language",
    "recipientEmail": "email",
    "recipientAddress": "address",
    "recipientPostalCode": "ZIP code",
    "recipientCity": "city",
    "recipientCountry": "country",
    "details": "details",
    "comments": "comments",
    "paymentAmount": "amount",
    "paymentStatus": "payment status",
    "paymentDate": "payment date",
    "adults": "adults",
    "children": "children",
    "external": "external",
    "external_source": "source",
    "tickets": "tickets",
    "voucher": "voucher",
    "available_vouchers": "available vouchers",
    "confirm_message": "are you sure you want to delete this voucher?",
    "unpaid_vouchers": "Warning! unpaid vouchers",
    "IMPORT": {
      "import": "import",
      "upload_csv": "upload CSV",
      "upload_valid_csv_with_this_header": "upload a valid CSV with the following header",
      "example_with_2_adults": "example of a voucher with 2 adults",
      "choose_file": "choose file",
      "check_file": "check file",
      "check_errors": "check errors",
      "not_a_valid_CSV": "this is not a valid CSV",
      "valid_CSV": "no validation errors",
      "click_import": "click import",
      "number_of_vouchers": "number of vouchers",
      "import_status": "import status",
      "imported_succesfully": "successfully imported",
      "imported_with_errors": "errors during import",
      "finish": "finish",
      "row": "row",
      "error_more_less_columns": "more or less columns than expected",
      "error_header": "error in the header",
      "error_contact_name": "error in contactName, this field is mandatory",
      "error_contact_phone": "error in contactPhone, this field is mandatory and in the format M:+32...",
      "error_contact_language": "error in contactLanguage, this field is mandatory'",
      "error_voucher_type": "error in voucher type, this field is mandatory",
      "error_voucher_reference": "error in voucher reference, this field is mandatory",
      "error_issue_date": "error in issue date, this field is mandatory and in the format YYYY-MM-DD",
      "error_expiry_date": "error in expiry date, this field is mandatory and in the format YYYY-MM-DD",
      "error_payment_date": "error in payment date, this field is mandatory and in the format YYYY-MM-DD",
      "error_payment_status": "error in payment status, this field is mandatory and accepted values are OPEN or PAID",
      "error_payment_type": "error in payment type, this field is mandatory and accepted values are NOPA, CASH, WIRE, BANC, CRED, ONLI",
      "error_adults": "error in adults, this must be a number",
      "error_children": "error in children, this must be number",
      "error_import": "error during import",
      "succes_import": "imported successfully",
      "cancel": "cancel"
    }
  },
  "BOOKINGS": {
  	"email_export_tooltip_open_amount": "with an open balance",
    "email_passengers": "email passengers",
    "email_export_tooltip": "export passenger email addresses to CSV",
    "email_export_tooltip_dynamic": "Download all {{filter}} passenger email addresses{{extras}}",
    "email_export_tooltip_tags": "tagged {{tags}}",
    "email_export_tooltip_search": "matching '{{search}}'",
    "email_export_success": "exported {{count}} email addresses",
    "email_export_empty": "no passenger email addresses to export",
    "id": "id",
    "availability": "availability",
    "PERI": "availability any date",
    "DATE": "availability on a specific date",
    "MOR": "morning",
    "EVE": "evening",
    "mo": "mo",
    "tu": "tu",
    "we": "we",
    "th": "th",
    "fr": "fr",
    "sa": "sa",
    "su": "su",
    "save": "save",
    "child": "child",
    "name": "name",
    "weight": "weight",
    "luggage": "luggage",
    "paymentType": "payment type ",
    "paymentReference": "payment reference ",
    "paymentAmount": "payment amount",
    "paymentStatus": "payment status",
    "paymentDate": "payment date",
    "delete": "delete",
    "OPEN": "open",
    "UNK": "added",
    "INV": "invited",
    "CON": "confirmed",
    "completed": "completed",
    "CAN": "cancelled",
    "CPP": "commercial private passengers",
    "COP": "commercial passengers",
    "NCP": "non commercial passengers",
    "booking_date": "booking date",
    "days_expired": "{{ d }} days expired",
    "startDate": "start date",
    "endDate": "end date",
    "status": "status",
    "bookingType": "booking type",
    "bookingCode": "booking reference",
    "bookingCodeHint": "click to launch the app for passengers",
    "bookingCodeMissingEmail": "without email, the passengers have no access to the booking in the app for passengers",
    "commentsTitle": "comments",
    "comments": "internal comments",
    "pax_comments": "comments from passenger",
    "region": "regio",
    "source": "source",
    "new_source": "new source",
    "you_can_manage_all_sources_in_settings": "you can manage all sources in settings",
    "source_validation": "source is mandatory, min 3, max 50 characters and must be unique",
    "source_list_validation": "choose a source from the list or create a new source first",
    "source_list_empty": "no sources found, click new source",
    "locationType": "location",
    "REGI": "all locations in a region",
    "FIXE": "specific location in a regio",
    "PRIV": "private location",
    "contactPerson": "contact person",
    "logsRemoved": "number of times removed from a flight",
    "contactName": "contact name ",
    "contactPhone": "contact phone",
    "contactEmail": "contact email ",
    "contactLanguage": "contact language ",
    "action_needed": "action needed",
    "answer_flight_yes_no": "answer FLIGHT YES or FLIGHT NO",
    "flight_yes": "FLIGHT YES",
    "flight_no": "FLIGHT NO",
    "PAID": "paid",
    "REFUNDED": "refunded",
    "not_paid": "to pay",
    "CASH": "cash",
    "COUP": "voucher (in system)",
    "VOUC": "voucher",
    "NOPA": "no payment",
    "CHEQ": "cheque",
    "WIRE": "wire transfer",
    "BANC": "bancontact",
    "CRED": "credit card",
    "ONLI": "online",
    "INVO": "invoice",
    "only_available_with_paymenttype_voucher": "only available with payment type voucher",
    "bookings": "bookings",
    "booking": "booking",
    "confirm": "confirm",
    "update": "update",
    "contact": "contact",
    "passengers": "passengers",
    "cancel": "cancel",
    "next": "next",
    "flightDate": "flight date",
    "flightPeriod": "flight period",
    "flight_balloon": "flight balloon",
    "flight_location": "flight location",
    "flight_pilot": "flight pilot",
    "add_passenger": "add passenger",
    "messages": "messages",
    "no_bookings_found": "no bookings found",
    "inviteCount": "invites",
    "confirm_message": "are you sure you want to delete this booking?",
    "delete_blocked_on_flight": "Remove this booking from its flight before you can delete it.",
    "always_available": "always available",
    "limited_availability": "limited availability",
    "end_before": "vlucht voor",
    "passenger": "passenger",
    "details": "details",
    "payment_details": "payments",
    "address_details": "address info",
    "disability": "assistance required",
    "category": "category",
    "address": "address",
    "postalCode": "postal code",
    "city": "city",
    "country": "country",
    "signature": "signature",
    "added_flight": "selected flight",
    "select_flight": "select flight",
    "no_flight_added": "no flight selected",
    "no_flight_data": "flight data is only shown if the location and date is fixed",
    "available_flights": "available flights",
    "no_available_flights": "no flights available",
    "available_balloons": "available balloons",
    "no_available_balloons": "no balloons available",
    "totalAmount": "total amount",
    "paid_amount": "paid",
    "openAmount": "open amount",
    "prepayment": "prepayment",
    "prepaymentDate": "prepayment date",
    "passengers_to_pay": "passenger(s) to pay",
    "default_weight_warning": "Default weight - needs confirmation",
    "passengers_with_default_weight": "{{ count }} passenger(s) with default weight",
    "confirm_weight": "Confirm weight",
    "mark_paid": "mark as paid",
    "remove_from_passengerlist": "remove from passenger list",
    "add_to_passengerlist": "add additional passenger",
    "checkin_passengers": "back to check in",
    "view_checked_in": "show checked in pax",
    "hide_checked_in": "hide checked in pax",
    "check_in_all": "checkin all pax",
    "import": "import",
    "upload_csv": "upload CSV",
    "upload_valid_csv_with_this_header": "upload a valid CSV file with the following header",
    "example_in_region_with_id_1_with_2_adults_and_0_children": "example of a booking with 2 adults in region with Id 1",
    "choose_file": "select file",
    "check_file": "check file",
    "check_errors": "correct the following errors",
    "not_a_valid_CSV": "this is not a valid file",
    "valid_CSV": "there are no errors",
    "click_import": "click to import",
    "number_of_bookings": "number of bookings",
    "number_of_objects_upcoming": "upcoming",
    "number_of_objects_history": "historical",
    "import_status": "import status",
    "imported_succesfully": "succesfully imported",
    "imported_with_errors": "errors during import",
    "finish": "finish",
    "row": "row",
    "error_more_less_columns": "more or less columns than expected",
    "error_header": "error in the header",
    "error_contact_name": "error in contactName, this field is mandatory",
    "error_contact_phone": "error in contactPhone, this field is mandatory and in the format M:+32...",
    "error_contact_language": "error in contactLanguage, this field is mandatory",
    "error_region": "error in region, this field is mandatory and must have the ID of the region",
    "error_adults": "error in adults, this must be a number",
    "error_children": "error in children, this must be a number",
    "errorImport": "error during import",
    "succesImport": "imported succesfully",
    "flight_confirmation": "flight confirmation",
    "date_filter_is_yyyy-mm-dd": "date filter = yyyy-mm-dd",
    "FILTER": {
    	"standard": "all active",
    	"standard_desc": "everything still to fly",
    	"toPlan": "to plan",
    	"toPlan_desc": "no flight yet",
    	"toConfirm": "to confirm",
    	"toConfirm_desc": "requested by the passenger",
    	"invited": "invited",
    	"invited_desc": "waiting for the passenger's reply",
    	"confirmed": "confirmed",
    	"confirmed_desc": "fixed on a flight",
    	"expired": "expired",
    	"expired_desc": "validity ended, not flown yet",
    	"history": "closed",
    	"history_desc": "flown or cancelled"
    },
    "import_bookings": "import bookings (CSV)",
    "expired_on_flight_date": "not valid anymore on the flight date",
    "flight_confirmed": "flight confirmed",
    "invited_waiting_answer": "invited, waiting answer",
    "MERGE": {
      "merge": "merge",
      "load": "load",
      "restart": "restart",
      "select_booking": "select bookings",
      "select_booking_hint": "the left side booking will be deleted, the right side booking will be saved",
      "merge_booking": "merge bookings",
      "merge_booking_hint": "give your consent before you can save and delete",
      "booking_id_to_delete": "booking id to delete",
      "booking_id_to_merge": "booking id to merge",
      "error_loading": "error during loading, select another id or restart",
      "warning_to_switch": "warning: you choose to delete the most recent reservation",
      "save_and_delete": "save this reservation and delete",
      "confirm_to_delete": "consent to delete",
      "replace": "replace",
      "add": "add",
      "undo": "undo",
      "fields_are_identical": "fields are identical",
      "remove": "remove"
    },
    "LOG": {
      "logbook": "logbook",
      "outbox": "sent emails",
      "only_logs_from_UI": "logging from Quick Release (not from UP or from website)",
      "ADDE": "added to the flight",
      "REMO": "removed from the flight",
      "CONF": "confirmed for the flight",
      "cancel": "flight cancelled, moved to booking list",
      "COMP": "flight executed, moved to history (completed)",
      "INVI": "invited by MSG to the flight",
      "CREA": "booking created in the system",
      "update": "booking updated one or more fields",
      "DELE": "booking deleted from the system",
      "MAIL": "email sent",
      "TRANSFER": "transferred to another basket",
      "view_email": "show email",
      "flight": "flight"
    },
    "vat_number": "VAT number",
    "invoice_name": "invoice name",
    "age": "age",
    "transport": "transport",
    "age_amount": "years"
  },
  "COMMUNICATIONS": {
    "RETENTION": {
      "title": "message retention",
      "explanation": "Choose how long messages are kept. Older messages disappear from the dashboard immediately and are permanently deleted after 90 days — within those 90 days you can recover them by changing the setting back. Messages of open bookings are always kept. As data controller you are responsible for choosing and justifying the retention period.",
      "closedBookings": "closed bookings",
      "crew": "crew",
      "never": "never (keep forever)",
      "years": "years",
      "year": "year",
      "recommended": "recommended: 2 years",
      "recommendedShort": "recommended",
      "confirmTitle": "delete old messages?",
      "confirmBody": "{{total}} messages ({{closedBookingMessages}} from closed bookings, {{crewMessages}} from crew) will disappear now and be permanently deleted after 90 days. Within those 90 days you can recover them by changing the setting back; after that they are gone for good.",
      "policyClosedYears": "Messages of closed bookings are deleted once the message itself is older than {{years}} year(s).",
      "policyClosedNever": "Messages of closed bookings are kept forever. Note: this blocks connecting a new WhatsApp session.",
      "policyCrewYears": "Crew messages are deleted once the message itself is older than {{years}} year(s).",
      "policyCrewNever": "Crew messages are kept forever.",
      "pendingDeletion": "{{count}} messages are scheduled for deletion — in {{days}} days they will be permanently deleted.",
      "connectBlocked": "To connect WhatsApp you must first set a message retention period for closed bookings (see \"message retention\" below)."
    },
    "sent_at": "sent at",
    "phone": "phone",
    "name": "name",
    "text": "text",
    "status": "status",
    "message_id": "message id",
    "message_price": "message price",
    "network": "network",
    "remaining_balance": "remaining balance",
    "received_at": "received at",
    "msisdn": "msisdn",
    "message_timestamp": "message timestamp",
    "keyword": "keyword",
    "pilot_invitation_sms": "MSG to pilots",
    "crew_invitation_sms": "MSG to crew",
    "checkin_notification_sms": "check-in invitation",
    "booking_confirmation_sms": "booking confirmation",
    "passenger_invitation_sms": "MSG to passengers",
    "cancel_sms": "MSG to cancel",
    "reminder_sms": "MSG to remind",
    "reminder_wa": "WhatsApp to remind",
    "sms_in": "incoming sms",
    "messages": "messages",
    "flight": "flight",
    "booking": "booking",
    "crew": "crew",
    "sms_out": "outgoing sms",
    "to": "to",
    "unanswered_messages": "unanswered messages",
    "mark_all_as_read": "mark all {0} messages as read",
    "mark": "mark",
    "mark_all": "mark all",
    "mark_paid": "mark paid",
    "mark_not_paid": "mark not paid",
    "messages_as_read": "messages as read",
    "you": "you",
    "mail_copy": "Email PDF",
    "action_succeed": "action successful",
    "accepted": "accepted",
    "delivered": "delivered",
    "sent": "sent",
    "failed": "failed to deliver",
    "unknown": "unknown error",
    "retry": "retry later",
    "wrongnumber": "wrong number",
    "none": "none",
    "fallback_hint": "WhatsApp offline — SMS credits available. Enable SMS fallback in settings.",
    "WHATSAPP": {
      "CHANNEL": {
          "chooser": "WhatsApp channel",
          "free": "WhatsApp free",
          "freeHint": "linked device — free of charge, but unofficial; Meta may block it",
          "business": "WhatsApp Business",
          "businessHint": "official Meta channel via your own Meta account — no blocks, paid per message",
          "active": "active",
          "settingUp": "being set up",
          "freeInactiveExplain": "WhatsApp Business is currently your active channel. To go back to WhatsApp free, your number is disconnected from the Meta API and you then re-pair your phone with a QR code. SMS fallback covers the transition. Note: Meta may block the free channel again."
      },
      "CLOUD": {
          "dialogWindowNote": "Recipients who have not messaged you in the last 24 hours receive the approved template wording; your edits only reach recipients within the 24-hour window.",
          "windowAllOpen": "All recipients are within the 24-hour window — your text is sent over WhatsApp exactly as written.",
          "windowSomeClosed": "{{count}} of {{total}} recipient(s) are outside the 24-hour window — they receive the approved template wording.",
          "windowEditedWarning": "Careful: you edited the text. The {{count}} recipient(s) outside the 24-hour window will still receive the APPROVED TEMPLATE wording — your edits only reach recipients within the window.",
          "auxTemplateOutOfWindow": "Recipients outside the 24-hour window receive the UP link and the flight options as a fixed template message (wording set by Quick Release, not editable).",
          "noFlightTypesHidden": "This booking has no flight planned yet — templates that carry flight details (invitation, reminder, check-in, cancellation) are therefore hidden.",
          "windowClosedFreeform": "Outside the 24-hour window — use a template.",
          "templatePickerButton": "template",
          "title": "WhatsApp channel",
          "subtitle": "Choose how WhatsApp messages are sent: WhatsApp free (linked device) or WhatsApp Business (official, via your own Meta account). You can switch in both directions.",
          "intro": "WhatsApp Business sends your messages over the official Meta API: no linked phone, no risk of being blocked, and delivery confirmations per message.",
          "introBilling": "It is a paid channel: you connect your own Meta business account with your own payment method, and Meta bills you directly. Quick Release does not charge for these messages.",
          "introCostEstimate": "Estimate based on your messages from the past {{months}} months: ± {{cost}} per month. On average you sent {{total}} WhatsApp messages per month, of which ± {{billable}} fell outside the 24h window — only those are paid (± €0.03 per message); messages within 24h of a customer reply are free.",
          "introCostEstimateSms": "Estimate based on your SMS history from the past {{months}} months: ± {{cost}} per month. On average you sent {{total}} messages per month, of which ± {{billable}} would fall outside the 24h window — only those are paid (± €0.03 per message); messages within 24h of a customer reply are free.",
          "introTemplates": "Messages outside a 24-hour customer window are sent with your approved message templates; replies within the window remain free-form and free of charge.",
          "startSignup": "connect with Meta",
          "reconnectMeta": "reconnect Meta account",
          "signupCancelled": "Meta signup was not completed. Your current WhatsApp settings are unchanged.",
          "signupSuccess": "WhatsApp Business account connected {{phone}}. Your message templates are being prepared.",
          "provisioningIntro": "Your Meta account is connected. Complete the steps below, then activate WhatsApp Business. Until then your messages keep using the current channel.",
          "stepWaba": "WhatsApp Business account connected",
          "stepNumber": "Phone number registered",
          "stepPayment": "Payment method added in Meta Business Suite",
          "stepTemplates": "Message templates approved by Meta",
          "paymentExplain": "Meta bills you directly on your own account. Add a payment method in Meta Business Suite (Billing), then confirm here. Without it, template messages will stop sending.",
          "openMetaBilling": "open Meta billing",
          "paymentConfirm": "I added my payment method",
          "paymentActionNeeded": "Meta reported a payment problem on your account. Messages are falling back to SMS. Check your payment method in Meta Business Suite and confirm below.",
          "activate": "activate WhatsApp Business",
          "activateConfirmTitle": "Activate WhatsApp Business?",
          "activateConfirmBody": "From now on your WhatsApp messages are sent via the official Meta API on your own account. You can switch back at any time.",
          "activateConfirmBodyNoPayment": "You have not confirmed a payment method yet. Free messages will work, but paid template messages will fail to SMS until Meta has a payment method. Activate anyway?",
          "activated": "WhatsApp Business is active.",
          "activeTitle": "WhatsApp Business active",
          "messagingTier": "messaging limit",
          "templatesServing": "{{count}} message template(s) approved and in use.",
          "switchBack": "switch back to WhatsApp free",
          "switchBackConfirmTitle": "Switch back to WhatsApp free?",
          "switchBackConfirmBody": "Your number is released from the Meta API and you pair it again as a linked device (QR code). SMS fallback covers the gap during the switch. Note: the free channel can be blocked by Meta again.",
          "switchedBack": "Switched back to WhatsApp free. Pair your phone with the QR code below.",
          "statusApproved": "approved",
          "statusPending": "waiting for Meta approval",
          "statusPendingSince": "waiting for Meta approval for {{elapsed}}",
          "statusRejected": "rejected by Meta",
          "statusBlocked": "wording needs a fix",
          "fixWordingHint": "Fix the wording in the message templates screen and save - it is then automatically resubmitted to Meta.",
          "freeChannelNote": "WhatsApp free works via a linked device on an unofficial connection; Meta can block or disconnect it. Consider WhatsApp Business for a guaranteed channel.",
          "metaLinksHint": "Your account, your number and the template review live at Meta — check them in WhatsApp Manager on your own account.",
          "openMetaAccount": "open WhatsApp Manager",
          "openMetaTemplates": "message templates at Meta",
          "openMetaNumbers": "phone numbers at Meta",
          "beforeYouStart": "before you start, at Meta",
          "prereqBusiness": "A Meta business account (Meta Business Portfolio) in your company's name — create it first if you do not have one.",
          "prereqPayment": "A payment method on that Meta account: Meta bills the paid messages directly to you.",
          "prereqNumber": "A phone number for WhatsApp: a new number, or your current WhatsApp Business number (it keeps working on your phone).",
          "openMetaBusiness": "open Meta Business",
          "openManual": "read the manual"
      },
      "settings": "settings",
      "whatsapp_OFF": "WhatsApp is disabled",
      "whatsapp_OFF_hint": "Contact us to enable WhatsApp if you have a WhatsApp for Business number. WhatsApp via your private number is not supported.",
      "whatsapp_ON": "WhatsApp is enabled",
      "whatsapp_ON_hint": "All messages are sent via WhatsApp. Choose to use SMS as a backup if WhatsApp is unavailable for your customer.",
      "whatsapp_TRIAL": "WhatsApp is in trial mode",
      "whatsapp_TRIAL_hint": "You will always be asked to choose between SMS or WhatsApp.",
      "fallbackSMS": "fallback to SMS",
      "fallbackSMS_hint": "use SMS if WhatsApp is unavailable",
      "fallbackSMS_no_credits": "no SMS credits available. Top up to enable SMS fallback.",
      "connection": "connection",
      "device_connected_successfully": "device connected successfully",
      "connect_your_device": "connect your device",
      "connect": "connect",
      "disconnect": "disconnect",
      "device": "device",
      "phone": "phone",
      "checking_device": "checking device",
      "not_supported_wa_message": "not supported WhatsApp message"
    }
  },
  "DASHBOARDS": {
    "flights": "flights",
    "no_flights": "no flights",
    "upcoming": "upcoming",
    "historical": "finished",
    "this_month": "this month",
    "bookings": "open bookings",
    "vouchers": "vouchers",
    "open": "open",
    "completed": "completed",
    "expired": "expired",
    "idea_voting": "idea voting",
    "search": "search",
    "payments": "payments",
    "charts": "charts",
    "flights_of_today_and_tomorrow_morning": "all flights of today and tomorrow morning",
    "flights_of_next_7_days": "all flights of next 7 days",
    "bookings_to_confirm_bookmarked_and_of_today_or_tomorrow_morning": "all bookings to confirm, bookmarked or booked for today or tomorrow morning, the new reservations or with a dashboard-tag",
    "basic_charts_of_reservations_and_flights": "basic charts of bookings and flights",
    "charts_are_no_longer_shown_on_the_dashboard_please_navigate_to_reports": "charts are no longer shown on the dashboard, please navigate to reports",
    "navigate_to_reports": "Navigate to reports",
    "most_recent_sms_per_contact": "most recent conversations",
    "messages_bookings": "messages bookings",
    "messages_crew": "messages crew",
    "messages": "messages",
    "sms_bookings": "SMS bookings",
    "sms_crew": "SMS crew",
    "show_all_messages": "all",
    "show_messags_from_this_flight": "show only this flight",
    "show_messages_from_this_booking": "show only this booking",
    "show_unread": "unread"
  },
  "FLIGHTS": {
    "LIST_FILTER": {
    	"upcoming": "upcoming",
    	"upcoming_desc": "still to fly, or within the last 7 days",
    	"older": "not closed (older)",
    	"older_desc": "scheduled more than 7 days ago, not closed yet",
    	"historical": "finished",
    	"historical_desc": "flown or cancelled"
    },
    "show_expired_on_flight_date": "show expired on flight date ({{n}})",
    "BULK": {
      "selected": "{{count}} selected (max. {{limit}})",
      "clear_selection": "Clear selection",
      "select_all_matching": "Select all matching flights",
      "actions": "Bulk action",
      "choose_action": "Choose action",
      "deselect_all": "Deselect all",
      "make_public": "Make public",
      "make_private": "Make private",
      "download_csv": "Download CSV",
      "ACTION": {
        "SET_VISIBILITY_PUB": "Make flights public",
        "SET_VISIBILITY_PRI": "Make flights private",
        "ADD_TAG": "Add tag",
        "REMOVE_TAG": "Remove tag",
        "CANCEL": "Cancel flights",
        "DELETE": "Delete flights"
      },
      "recent_actions": "Bulk actions of the last 24 hours",
      "no_recent_actions": "No bulk actions in the last 24 hours",
      "undone": "undone",
      "undone_by": "Undone by {{user}}",
      "too_many_matches": "{{total}} flights match this filter. Bulk actions are limited to {{limit}} flights at a time. Narrow down the search, period or tag filter, for example one month at a time.",
      "limit_reached": "You can select at most {{limit}} flights for a bulk action. Narrow down the search, period or tag filter.",
      "no_matches": "No flights match this filter.",
      "confirm_selected": "{{count}} flights selected.",
      "date_range": "Period",
      "will_update": "{{count}} will be changed",
      "will_stay_unchanged": "{{count}} already have this setting",
      "will_skip": "{{count}} will be skipped",
      "undo_hint": "You can undo this action once within 24 hours.",
      "apply": "Apply to {{count}} flights",
      "updated": "{{count}} changed",
      "unchanged": "{{count}} unchanged",
      "skipped": "{{count}} skipped",
      "restored": "{{count}} restored",
      "not_restored": "{{count}} not restored",
      "undo": "Undo",
      "undo_available_until": "Undo possible until",
      "SKIP": {
        "NOT_FOUND": "flight no longer exists",
        "NOT_UPCOMING": "flight is cancelled or finished",
        "HAS_BOOKINGS_FUTURE": "has bookings: cancel it individually so passengers are informed",
        "HAS_BOOKINGS": "has bookings",
        "NOT_SCHEDULED": "only scheduled flights can be deleted",
        "ERROR": "unexpected error"
      },
      "UNDO_SKIP": {
        "CHANGED_SINCE": "changed since, not undone",
        "NOT_FOUND": "flight no longer exists",
        "DELETED": "booking deleted",
        "ON_OTHER_FLIGHT": "booking planned on another flight",
        "NOT_OPEN": "booking no longer open",
        "ERROR": "unexpected error"
      }
    },
    "CANCEL": {
      "title": "cancel flight",
      "reason_from_message": "reason: {{reason}}",
      "change_reason": "change",
      "cancel_and_send": "cancel and send message",
      "cancel_and_send_crew": "cancel and send message + crew",
      "cancel_only": "cancel only",
      "cancel_only_warning": "the passengers will not be notified",
      "confirm": "confirm",
      "already_sent": "cancellation message already sent",
      "send_failed": "the message could not be sent — the flight was not cancelled",
      "back": "back"
    },
    "cancel_message_only": "send cancellation message only",
    "cancel_message_sent_chip": "cancellation message sent — flight not cancelled yet",
    "passengers_not_notified": "passengers were not notified",
    "CHECKIN_LOG": {
    	"title": "pilot check-in",
    	"empty": "no changes were made during mobile check-in",
    	"signoff_cleared": "pilot sign-off cleared",
    	"signoff_signed": "pilot signed off"
    },
    "cancelled_bookings": {
      "title": "passengers at cancellation",
      "send_message": "send cancellation message",
      "restore": "restore flight",
      "restore_confirm": "The flight will be restored and the passengers that were on it will be added again. Bookings that were meanwhile placed on another flight are left untouched.",
      "restore_done": "Flight restored, {{count}} booking(s) re-attached.",
      "restore_skipped": "Not restored: {{skipped}}.",
      "skip_DELETED": "booking no longer exists",
      "skip_ON_OTHER_FLIGHT": "meanwhile on another flight",
      "skip_NOT_OPEN": "booking is no longer open"
    },
    "save": "save",
    "reset": "reset default",
    "unknown": "unknown",
    "CON": "confirmed",
    "invited_by_sms": "invited by sms",
    "DEC": "declined ",
    "MOR": "morning",
    "EVE": "evening",
    "CPF": "commercial private flight",
    "COF": "commercial flight",
    "NCF": "non commercial flight",
    "PRI": "not shared",
    "PUB": "shared",
    "SCH": "scheduled",
    "REA": "ready",
    "MARK": {
      "SCH": "schedule",
      "REA": "set ready",
      "CAN": "cancel",
      "FIN": "finish"
    },
    "INFO": {
      "SCH": "get your stuff together and set ready to fly",
      "REA": "well done! This flight is ready to release",
      "CAN": "this flight is cancelled, you can remove it from the system",
      "FIN": "this flight is done, great job!"
    },
    "checkin": "check in",
    "CAN": "cancelled",
    "FIN": "finished",
    "balloon": "hot air balloon",
    "date": "date",
    "period": "period",
    "event": "event",
    "hour": "time",
    "hourMeeting": "meeting time",
    "sunrise": "sunrise",
    "sunset": "sunset",
    "flight_type": "flight type",
    "location": "location ",
    "visibility": "visibility",
    "web": "web",
    "status": "status",
    "comment": "comment",
    "crew_comments": "crew comments",
    "pilot": "pilot ",
    "pilot_status": "status",
    "action_needed": "action needed",
    "ground_crew": "crew ",
    "pilot_and_crew": "pilot and crew",
    "not_enough_data": "not enough data",
    "answer_pilot_yes_no": "Answer PILOT YES or PILOT NO.",
    "pilot_yes": "PILOT YES",
    "pilot_no": "PILOT NO",
    "Flight date cannot be set in the past": "Flight date cannot be set in the past",
    "answer_crew_yes_no": "Answer CREW YES or CREW NO.",
    "crew_yes": "CREW YES",
    "crew_no": "CREW NO",
    "flights": "flights",
    "flight_bookings": "flight bookings",
    "UNK": "added",
    "INV": "invited by sms",
    "invite_all": "SMS invite all",
    "inviteCount": "invites",
    "invite_count_1": "invite",
    "mo": "mo",
    "tu": "tu",
    "we": "we",
    "th": "th",
    "fr": "fr",
    "sa": "sa",
    "su": "su",
    "invite": "send sms",
    "mail": "email",
    "reply": "Type your reply message here",
    "sms": "sms",
    "whatsapp": "WhatsApp",
    "whatsapp_sms": "WhatsApp (backup sms)",
    "message": "message",
    "message_whatsapp": "WhatsApp message",
    "message_sms_fallback": "SMS fallback message",
    "confirm": "confirm",
    "remove": "remove",
    "contactName": "contact name",
    "bookingType": "booking type",
    "region": "region",
    "passengers": "passengers",
    "no_bookings_selected": "no bookings selected",
    "matching_bookings": "bookings",
    "mismatching_bookings": "bookings on another flight",
    "mismatchReasons": "flight matching",
    "add_all": "add all",
    "add": "add",
    "add_and_confirm": "add + confirm",
    "already_added": "already added",
    "messages": "messages",
    "calendar": "calendar",
    "download_manifest": "download manifest",
    "send_sms_reminder": "send sms reminder",
    "update": "update",
    "are_you_sure": "are you sure",
    "reminder_sms_will_be_sent": "a reminder SMS will be sent",
    "edit_sms": "edit SMS",
    "edit_wa": "edit  WhatsApp",
    "preview_sms": "preview",
    "send": "send",
    "send_to_pax": "send to PAX",
    "send_to_pax_and_crew": "send to PAX and CREW",
    "send_up_url_with_sms": "send UP url with SMS",
    "send_up_url_with_msg": "send UP url with MSG",
    "upTitle": "Go directly to your personal booking page via this link!\n[personal link will be sent]",
    "flightOptions": "flight options",
    "flightOptionsTitle": "We’d be delighted to welcome you on one of the following dates:\n[personal list of flights with sufficient seats will be sent]",
    "send_flightoptions_with_msg": "send flight options with MSG",
    "sent": "sent",
    "message_has_been_sent": "message has been sent",
    "message_has_not_been_sent": "message has not been sent",
    "not_sent": "not sent",
    "not_confirmed_bookings_will_be_removed_from_flight": "the following not confirmed bookings will be removed from the flight",
    "flight_will_be_cancelled": "flight will be cancelled",
    "flight_will_be_finished": "flight will be finished",
    "flight_will_be_reopened": "flight will go back to the planning",
    "yes_cancel_it": "yes cancel it",
    "no_please": "no please",
    "cancel_sms_will_be_sent": "cancel sms will be sent",
    "not_cancelled": "not cancelled",
    "flight_has_not_been_cancelled": "flight has not been cancelled",
    "confirm_message": "are you sure you want to delete this flight?",
    "flight_pilot_in_command": "flight pilot in command",
    "invite_by_sms": "send sms",
    "unsupported_phonenumber": "unsupported phonenumber",
    "sms_unclear": "sms unclear",
    "no_pilot_in_command_selected": "no pilot in command selected",
    "flight_crew": "flight crew",
    "no_crew_selected": "no crew selected",
    "available_pilots_and_crew": "available pilots and crew",
    "select_pilot": "select pilot",
    "select_crew": "select crew",
    "other_flight": "other flight",
    "add_as_crew": "add as crew",
    "add_as_pilot": "add as pilot",
    "warning": "warning",
    "creating_a_flight_can_lead_to_costs": "this action can generate costs",
    "proceed": "proceed",
    "cancel": "cancel",
    "passenger_count": "passenger count",
    "crew_count": "crew count",
    "type": "type",
    "no_pilot": "no pilot",
    "seats": "seats ",
    "delete": "delete",
    "set_ready": "ready",
    "address": "address",
    "postalCode": "ZIP",
    "city": "city",
    "country": "country",
    "manifest": "manifest",
    "certificates": "certificates",
    "takeoffTime": "takeoff time (LT)",
    "landingLocation": "landing location",
    "landingDetails": "landing details",
    "total_weight": "total weight",
    "landingTime": "landing time (LT)",
    "flightTime": "fly time",
    "and": "and",
    "name": "name",
    "ref": "ref",
    "amount": "amount (EUR)",
    "weight": "weight",
    "signature": "signature",
    "reminder_sms": "reminder SMS",
    "also_to_pilot_and_crew": "also to pilot and crew",
    "cancel_sms": "cancel SMS",
    "no_flights_found": "no flights found",
    "no_location": "no location",
    "show": "show",
    "hide": "hide",
    "lift": "lift",
    "lift_needed": "lift required",
    "lift_available": "lift available",
    "lift_spare": "spare lift",
    "lift_level_green": "lift margin OK",
    "lift_level_orange": "spare lift low",
    "lift_level_red": "spare lift too low",
    "lift_level_blue": "underloaded — may land below minimum landing mass (MLM)",
    "lift_level_unknown": "lift data incomplete",
    "takeoff_location": "Takeoff Location",
    "takeoff_height": "takeoff height",
    "maximum_height": "maximum altitude",
    "temp_takeoff": "takeoff temperature",
    "temp_takeoff_manual_hint": "manually set — click to use the Meteoblue temperature again",
    "temp": "temperature",
    "temp_max": "maximum height temperature",
    "weather_qfe": "takeoff pressure (QNH)",
    "weather_pmax": "maximum height pressure",
    "balloon_volume": "balloon volume",
    "balloon_temp": "max temp envelope",
    "create_add": "add to new flight",
    "weather": "weather",
    "copy_weather_to": "copy weather to",
    "use_meteoblue": "use meteoblue",
    "skeyes_ballooning_bulletin": "skeyes ballooning bulletin",
    "use_skeyes": "use Skeyes",
    "weather_forecast": "weather forecast",
    "no_weather_forecast": "no forecast available",
    "windSummary": "wind summary",
    "weather_source": "source",
    "weather_source_forced": "official source (weather settings)",
    "weather_forecast_date": "forecast date",
    "vfr_visual": "visibility",
    "vfr_clouds": "clouds",
    "wind_gl": "wind ground level",
    "wind_gl_short": "wind GL",
    "wind_dir": "direction",
    "wind_gl_direction": "wind direction ground level",
    "wind_10": "wind 1000FT",
    "wind_10_direction": "wind direction 1000FT",
    "wind_20": "wind 2000FT",
    "wind_20_direction": "wind direction 2000FT",
    "wind": "wind",
    "clear": "clear",
    "fuel_spare": "spare fuel",
    "planned_flight_time": "planned flight time",
    "spare_flight_time": "spare flight time",
    "maximum_flight_time": "available flight time",
    "select_balloon": "select the balloon",
    "select_location": "select the location",
    "offsets": "change sunrise/sunset offsets",
    "flight_hour_will_be_calculated_based_on_sunset_minus_the_offset_minutes": "the hour of the flight is calculated based on sunset (or sunrise) minus the offset minutes, rounded down to half an hour. Negative values are allowed (in case of sunrise).",
    "offset_sunrise": "offset sunrise (minutes)",
    "offset_sunset": "offset sunset (minutes)",
    "payment_overview": "payment overview",
    "go_back": "go back",
    "freeSpots": "free spots",
    "traject": {
      "trajectory": "trajectory",
      "custom_flight_profile": "custom flight profile",
      "duration": "duration",
      "duration_is_required": "duration is required",
      "level": "level",
      "level_is_required": "level is required",
      "save": "save",
      "no_trajectory_without_meteo": "no trajectory without meteo",
      "update_custom_profile": "update custom profile",
      "refresh_weather": "refresh weather",
      "talking_to_meteoblue": "talking to meteoblue",
      "refresh_hint": "meteoblue updates their weather model frequently. Refreshing is available again 4 hours after the last update."
    },
    "LANDING": {
      "landing": "landing",
      "landing_details": "details",
      "map": "map",
      "no_details": "no details available",
      "landing_data": "landing data can only be changed in the mobile check-in screen for now",
      "refuelVolume": "gas refuel volume",
      "update_log": "update log",
      "update_log_hint": "you can only change the landing data here. Open the flight to change all other flight data.",
      "open_flight": "open flight"
    },
    "FILTER": {
      "date_range_filter": "date range filter",
      "from": "from",
      "till": "till",
      "excluded": "excluded",
      "no_date_filter_active": "no date filter active",
      "enter_a_date_range": "enter a date range",
      "start_date": "start date",
      "end_date": "eind date",
      "month": "month",
      "week": "week",
      "day": "day",
      "flights": "flights"
    },
    "flight_no_bookings": "this flight has no bookings yet",
    "mor_flight": "morning flight",
    "eve_flight": "evening flight",
    "mor_flights": "morning flights",
    "eve_flights": "evening flights",
    "no_mor_flights": "no morning flights",
    "no_eve_flights": "no evening flights",
    "responded_pilots": "responded pilots",
    "delete_flight": "delete flight",
    "toggle_visibility": "change visibility",
    "tags": "tags",
    "COPY": {
      "copy_flight": "copy flight",
      "select_multiple_dates": "select multiple dates to copy the same flight with the same location, balloon, pilot and crew",
      "selected_dates": "selected dates",
      "no_tags": "no tags",
      "copy": "copy"
    },
    "PILOTANDCREW": {
      "selected": "selected",
      "most_used": "most used",
      "this_is_the_most_used_pilot_and_crew": "this is the most used pilot and crew for this balloon",
      "accept": "accept",
      "all_pilots_and_crew": "all pilots and crew",
      "select": "select"
    },
    "FREESPOTS": {
      "showAll": "Show all flights",
      "showOverbookings": "Show overbookings",
      "freeSpots": "Show all flights with {{count}} or more free spots",
      "showMore": "Show more options"
    },
    "selected_flight": "Selected flight",
    "selected_flight_hint": "This booking is currently scheduled for this flight",
    "possible_flights": "Upcoming flights",
    "possible_flights_hint": "These are the upcoming flights that this booking can be scheduled for, taking into account available seats and tag restrictions",
    "balloon_cannot_accept_passengers": "Balloon cannot accept passengers",
    "balloon_in_use_tooltip": "The balloon is used on another flight with passengers. Change to another balloon to add passengers here.",
    "reduce_capacity_by_one_pax": "Reduce capacity by one passenger",
    "reset_capacity": "Reset capacity",
    "has_open_amount_tooltip": "This flight has bookings with an open amount"
  },
  "DISPLAYEDCOLUMNS": {
    "hint": "Select columns and change the order with drag 'n drop as you prefer",
    "warning": "Attention, you need to reset your preferences after changes to the column definitions",
    "flightsUpcoming": "Columns for upcoming flights",
    "flightsBooking": "Columns for flights from bookings",
    "flightsHistory": "Columns for historical flights",
    "bookingsOpen": "Columns for open bookings",
    "bookingsHistory": "Columns for historical bookings",
    "bookingsPayment": "Columns for payment follow-up",
    "bookingsDashboard": "Columns for bookings dashboard",
    "bookingsFlight": "Columns for bookings on a flight",
    "bookingsFlightEnd": "Columns for bookings on ended flight",
    "bookingsFlightCancelled": "Columns for bookings of a cancelled flight",
    "bookingsFlightAll": "Columns for bookings on a flight",
    "bookingsFlightPayment": "Columns for payment follow-up",
    "status": "status",
    "name": "balloon",
    "nameBadge": "balloon",
    "date": "date",
    "event": "event",
    "hour": "hour",
    "location": "location",
    "pilot": "pilot",
    "crew": "crew",
    "bookings": "bookings",
    "comments": "comments",
    "passengers": "passengers",
    "passengersWeight": "weight",
    "action": "action",
    "bookingDate": "booking date",
    "contactName": "contact name",
    "phone": "phone",
    "region": "region",
    "city": "city",
    "preferredDate": "availability",
    "flightDate": "flight date",
    "flightPeriod": "flight period",
    "flight_balloon": "flight balloon",
    "flight_location": "flight location",
    "flight_pilot": "flight pilot",
    "totalAmount": "total amount",
    "paid_amount": "paid",
    "openAmount": "balance",
    "flight_confirmation": "confirm flight",
    "messages": "messages",
    "up": "UP",
    "contactCard": "booking",
    "passengersCard": "passengers",
    "mismatchReasons": "flight matching",
    "mobile_view": "visible on mobile"
  },
  "MANIFEST": {
    "fuel_consumption": "fuel consumption",
    "fuel_needed": "fuel required",
    "fuel_available": "fuel available",
    "load_chart_and_passenger_list": "Load Calculations and Passenger List",
    "passenger_list": "Passenger List",
    "weather_conditions": "Weather Conditions",
    "fuel_calculations": "Fuel Calculations",
    "load_chart": "Load Calculations",
    "after_flight": "After Flight",
    "visible_defects": "Visible Defects",
    "yes_no": "Yes/No",
    "date": "date",
    "signature": "signature",
    "defect": "defect",
    "action": "action",
    "certificate": "certificate",
    "authority": "authority",
    "initials": "initials",
    "confirmation": "this confims that the specified actions were executed according PART-ML and that the aircraft is declared as ready for the next flight."
  },
  "LOCATIONS": {
    "name": "name",
    "description": "description",
    "region": "region",
    "address": "address",
    "postalCode": "postal code",
    "city": "city",
    "country": "country",
    "height": "takeoff elevation",
    "maximum height": "max altitude",
    "locations": "locations",
    "confirm_message": "are you sure you want to delete?",
    "confirm": "confirm",
    "update": "update",
    "delete": "delete",
    "regions": "regions",
    "save": "save",
    "add_location": "add location",
    "add_region": "add region",
    "hot_airfield": "hot airfield",
    "coordinates": "coordinates",
    "geolocate": "geolocate",
    "no_results": "no results",
    "contact": "contact",
    "takeoff_location": "takeoff Location",
    "takeoff_location_subtitle": "The coordinates of the takeoff location are used for the weather forecast, trajectory and lift calculation.",
    "meetingpoint": "meeting point",
    "meetingpoint_subtitle": "The address of the meeting point is communicated to the passengers (UP).",
    "same_as_takeoff": "same as takeoff location",
    "meetingpointAddress": "meeting point address",
    "search_address": "search address",
    "CONTACT": {
      "name": "name",
      "type": "type",
      "comment": "comment",
      "phone": "phone",
      "email": "email",
      "when_to_contact": "when to contact",
      "how_to_contact": "how to contact",
      "NOMSG": "no message",
      "MAIL": "email",
      "SMS": "msg",
      "mail": "during the preparation of the flight, you will be able to send an email to the contact person",
      "sms": "during the preparation of the flight, you will be able to send a msg to the contact person",
      "no_message": "no message will be sent to the contact person",
      "add_sms_template": "add msg template",
      "add_mail_template": "add email template",
      "mail_template": "email template",
      "sms_template": "msg template",
      "warning_email": "you did not send an email to the contact person",
      "warning_sms": "you did not send an sms to the contact person"
    }
  },
  "FLYABILITY": {
    "verdict_good": "good to fly",
    "verdict_marginal": "doubtful",
    "verdict_nogo": "probably not flyable",
    "no_assessment": "no assessment available",
    "all_within_limits": "all parameters within your limits",
    "unknown_excluded": "no data for {{parameters}} — not counted",
    "advisory": "This assessment is only an aid based on your own limits — the pilot in command decides.",
    "param_windGl": "surface wind",
    "param_wind500": "wind at 500 m",
    "param_gustSpread": "gusts above surface wind",
    "param_precipitation": "precipitation",
    "param_lowClouds": "low clouds",
    "param_visibility": "visibility"
  },
  "FORECAST": {
    "no_mobile": "Meteo is currently only supported on bigger screens",
    "select_favorite": "Select a location as favorite to show the meteoblue weather forecast",
    "no_forecast": "No meteo available for this location. Check latitude and longitude",
    "remove_favorite": "remove favorite",
    "mark_favorite": "mark favorite",
    "favorite_description": "this location is your favorite location. The meteoblue weather forecast is available on the dashboard for this location.",
    "non_favorite_description": "this location is not your favorite location. Mark it is your favorite to show the meteoblue weather forecast on the dashboard",
    "meteo": "meteo",
    "time": "time",
    "summary": "summary"
  },
  "REGIONS": {
    "name": "name",
    "locations": "locations",
    "no_locations_yet": "no locations yet",
    "name_required": "name required",
    "change_color": "click here to change the region color",
    "reset_color": "reset color",
    "confirm_color": "confirm color",
    "cancel_color": "cancel color",
    "openBookings": "open bookings",
    "notusedyet": "no bookings yet",
    "move": "move all bookings to another region",
    "select_target_region": "select the target region for all {0} bookings in this region"
  },
  "EVENTS": {
    "new_event": "new event",
    "information": "add an event on a specific date or load the public holidays",
    "new_crew_event": "new appointment",
    "crew_information": "add a busy appointment (unavailable to fly or crew)",
    "holidays": "holidays",
    "load_public_holidays_of_year_from_country": "load public holidays of {0} from {1}",
    "date": "date",
    "description": "description",
    "save": "save",
    "cancel": "cancel",
    "required": "required",
    "crew": "crew",
    "NO": "not available",
    "YES": "available",
    "MAYBE": "maybe available",
    "UNK": "availability unknown",
    "comment_availability": "What should we consider on",
    "comment": "comment"
  },
  "SETTINGS": {
    "VARIANTS": {
      "duplicate": "duplicate",
      "copySuffix": "(copy)",
      "reasonCode": "cancellation reason",
      "reasonCodeHint": "Picking this reason when cancelling preselects this message. A reason belongs to at most one message.",
      "reasonGeneral": "— none (general message) —",
      "reasonTaken": "used by {{label}}",
      "reasonRemoved": "(removed reason)",
      "default": "default",
            "add": "add variant",
            "remove": "remove variant",
            "label": "variant name",
            "labelHint": "Optional — distinguishes several wordings of the same message type (e.g. \"morning flight\", \"short notice\").",
            "picker": "wording",
            "variant": "variant",
            "waIssues": "WhatsApp Business cannot submit this wording",
            "waRejected": "Rejected by Meta",
            "waResubmitHint": "Adjust the wording and save — it is automatically resubmitted to Meta for approval.",
            "wabaColumn": "WhatsApp status",
            "ISSUES": {
                "VARIABLE_AT_START": "starts with a variable",
                "VARIABLE_AT_END": "ends with a variable",
                "ADJACENT_VARIABLES": "two variables directly after each other",
                "TOO_MANY_VARIABLES": "too many variables for the amount of fixed text",
                "UNKNOWN_PLACEHOLDER": "unknown variable for this message type",
                "TOO_LONG": "text is too long",
                "EMPTY_TEXT": "no text"
            }
        },
    "user_default_language": "user default language",
    "submit": "submit",
    "preferences_language": "language",
    "preferences_sms": "SMS",
    "smsTitle": "title",
    "smsTemplate": "template",
    "pilotInvitationSms": "pilot invitation SMS",
    "example": "example",
    "update": "update",
    "crewInvitationSms": "crew invitation SMS",
    "passengerInvitationSms": "passenger invitation SMS",
    "cancelSms": "cancel SMS",
    "reminderSms": "reminder SMS",
    "locationContactSms": "location contact SMS",
    "checkinNotificationSms": "check-in notification SMS",
    "bookingConfirmationSms": "booking confirmation SMS",
    "platformUpLink": "UP link (fixed template)",
    "platformFlightOptions": "flight options (fixed template)",
    "emailTitle": "title",
    "emailType": "type",
    "emailTo": "email to",
    "emailSubject": "subject",
    "emailBody": "body",
    "emailAttachments": "attachments",
    "emailAttachments_save_hint": "do not forget to save your template after adding or removing attachments",
    "emailTest": "email test",
    "mailFromEmail": "email account address",
    "mailFromName": "Email from name",
    "mailReplyToEmail": "Email Reply To Email",
    "mailAccountantName": "accountant's email name",
    "mailAccountantEmail": "accountant's email address",
    "bookingConfirmEmail": "Email confirmation booking",
    "bookingFlightCancelEmail": "Email end of flight",
    "bookingFlightConfirmEmail": "Email passengers of a flight",
    "crewFlightEmail": "Email flight details for crew",
    "crewOtpEmail": "Email login for crew",
    "pilotFlightEmail": "Email flight details for pilot",
    "flight_email": "Email flight details",
    "locationContactEmail": "Email contact on location",
    "checkinNotificationEmail": "Email check-in notification",
    "flight_email_passengers": "Email passengers",
    "flight_sms_passengers": "SMS passengers",
    "flight_msg_passengers": "MSG passengers",
    "load_default": "load a standard text",
    "passenger_categories": "passenger categories",
    "category_name": "name",
    "category_description": "description",
    "category_child": "child",
    "category_price": "price",
    "category_default": "default",
    "delete": "delete",
    "mobile_questions": "passenger questions (mobile)",
    "question": "question",
    "kind": "kind",
    "active": "active",
    "title": "title",
    "description": "description",
    "language": "language",
    "texts": "texts",
    "name": "name",
    "address": "address",
    "email": "email",
    "weight": "weight",
    "luggage": "luggage",
    "child": "child",
    "accompany": "accompany",
    "pay": "pay",
    "signature": "signature",
    "optional": "optional",
    "mandatory": "mandatory",
    "order": "order",
    "titles": "questions",
    "descriptions": "question texts",
    "yes": "yes",
    "no": "no",
    "nl": "dutch",
    "fr": "french",
    "en": "english",
    "de": "german",
    "es": "spanish",
    "id": "id",
    "download_sample": "download sample",
    "drag_and_drop_file_here": "drag and drop file here",
    "browse_for_file": "browse for file",
    "operator_settings": "operator settings",
    "operator_backup_and_sync": "backup en sync",
    "operator_bookings": "booking settings",
    "operator_flights": "flight settings",
    "operator_crew": "crew settings",
    "operator_myflight": "UP (Passengers App) settings",
    "operator_weather_source": "weather settings and NOTAM",
    "flyability": {
      "enabled": "show flyability on the weather card",
      "disabled_hint": "Off: the weather card and the flight detail look exactly as they do today, with no verdicts and no colours. Switch it on to judge every forecast slot against the limits below.",
      "band_good": "good",
      "band_marginal": "doubtful",
      "band_nogo": "do not fly",
      "explain_windGl": "Average wind speed at ground level during the flight window. This decides whether inflating, launching and landing can be done safely — it is the limit most flights are called off on.",
      "explain_wind500": "Wind speed at about 500 metres, the height a balloon spends most of its flight at. It sets how fast and how far you travel, and therefore how much landing area you need.",
      "explain_gustSpread": "How much stronger the gusts are than the steady ground wind. A gust spread of 8 kt on top of a calm 5 kt wind still means sudden pulls on the envelope during inflation and landing — which is why it is judged separately from the wind itself.",
      "explain_precipitation": "The heaviest rain expected during the flight window. A wet envelope is heavy and has to be dried afterwards, so most operators keep the good band at zero.",
      "explain_lowClouds": "The share of the sky covered by cloud below roughly 2 km. A lot of low cloud means a low cloud base and little sight of the ground: 0 % is a clear sky, 100 % is completely overcast.",
      "explain_visibility": "How far you can see horizontally. You need it to navigate, to spot other traffic and to pick a landing field in time. This is the one parameter where more is better, so its limits count upwards.",
      "title": "flyability limits",
      "hint": "The weather card colours every forecast slot green, orange or red against these limits. Leave a parameter on its default to keep following the platform value.",
      "good_upto": "good up to",
      "marginal_upto": "marginal up to",
      "good_from": "good from",
      "marginal_from": "marginal from",
      "is_default": "default",
      "reset": "reset to default",
      "reset_all": "reset all to default",
      "saved": "flyability limits saved",
      "error_required": "both values are required",
      "error_negative": "values cannot be negative",
      "error_order": "the good limit cannot be stricter than the marginal limit"
    },
    "weatherSource": {
        "title": "official weather source per country",
        "hint": "When enabled, the weather source on the flight and the Operational Flight Plan (OFP) is filled automatically with the official source for the country of the launch location, instead of free text.",
        "mapped": "force official weather source per country",
        "source": "weather source",
        "locations": "locations",
        "locationsWithoutCountry": "locations without a country (please set their country)",
        "addCountry": "add country"
    },
    "export": "export",
    "you_can_activate_a_daily_backup": "you can send a daily export in HTML to a specific e-mail address. As soon as you activate the export, you will receive immediately an export to the given e-mail address, then every day around 4am",
    "daily_backup": "daily export",
    "backup_email": "email address",
    "only_update_when_inactive": "you can only change the email address when the export is inactive",
    "exported_files": "exported files",
    "bookings": "all open bookings",
    "flights": "all planned flights",
    "vouchers": "all vouchers",
    "flights_bookings_passengers": "all planned flights with their bookings and passengers",
    "calendarUrl": "ICS URL for the calendar",
    "you_can_subscribe_to_all_flights_in_your_personal_calendar": "you can subscribe to all flights in your personal calendar",
    "geticsurl": "generate ICS URL",
    "readthedocs": "read the documentation",
    "crew": {
      "title": "Crew",
      "shareBookings": "crew can see the details of the bookings on a flight in the dashboard",
      "shareBookingsHint": "if this is not checked, the crew can only see the number of passengers on a flight in the dashboard",
      "allowFlightSelection": "crew can select flights in the calendar",
      "allowFlightSelectionHint": "if this is not checked, the crew can only see the flights in the calendar, but cannot select them",
      "shareEvents": "share calendar events with crew",
      "shareEventsHint": "if this is checked, operator events (e.g. holidays, company events) will be visible to crew in their calendar",
      "shareFlightTags": "share flight tags with crew",
      "shareFlightTagsHint": "if this is checked, flight tags will be visible to crew in their calendar",
      "crewReady": {
        "title": "Crew ready notification",
        "channel": "notification channel",
        "channelNone": "none (disabled)",
        "channelEmail": "email",
        "channelWhatsApp": "WhatsApp",
        "channelBoth": "Both (Email + WhatsApp)",
        "instructions": "crew instructions",
        "includePassengers": "include passengers in notification",
        "includeTrajectory": "include trajectory image in notification",
        "language": "notification language",
        "hint": "The crew is automatically informed by WhatsApp or email when the flight status changes to ready. The notification includes flight details and optionally passengers and trajectory.",
        "preview": "preview"
      }
    },
    "operator_notifications": "notifications",
    "notifications": {
      "title": "Email notifications",
      "title_calendar": "Email notification of availability change",
      "title_flightCrew": "Email notification of pilot and/or crew change for a flight",
      "calendar": "Receive an email when the availability of crew and pilots changes",
      "calendarHint": "if this is checked, the system will automatically send a clear email to the operator and crew 5 minutes after the crew or pilot updates one or more availabilities",
      "calendarClosing": "Closing text",
      "calendarClosingHint": "this closing text will be added to the email",
      "flightCrew": "Send an email when you add a pilot or crew member to a flight",
      "flightCrewHint": "if this is checked, an email will automatically be sent to the pilot and crew when you add or remove them from a flight",
      "save": "save"
    },
    "booking": {
      "title": "bookings",
      "childAge": "child age",
      "disabledPaymentTypes": "disabled payment types",
      "disabledPaymentTypesHint": "if you disable a payment type, it will not be shown in the booking process.",
      "none_of_the_paymentTypes_are_disabled": "none of the payment types are disabled",
      "disabledPaymentTypesSave": "save disabled payment types",
      "childAgeHint": "every passenger with this age or younger will be marked as a child",
      "sources": "sources",
      "flightOptionsCount": "number of flight options",
      "flightOptionsCountHint": "the number of upcoming balloon flights suitable for the reservation, taking into account the number of passengers and any restrictions (tags)."
    },
    "flight": {
      "title": "flights",
      "sunriseOffset": "sunrise offset",
      "sunriseOffsetHint": "the flight time is calculated based on sunrise minus the number of offset minutes, rounded down to the half hour.",
      "sunsetOffset": "sunset offset",
      "sunsetOffsetHint": "the flight time is calculated based on sunset minus the number of offset minutes, rounded down to the half hour.",
      "meetingTimeOffset": "meeting time offset",
      "meetingTimeOffsetHint": "the meeting time for the flight is calculated based on the flight time minus the number of offset minutes. If 0, the meeting time is not displayed.",
      "sunrise": "sunrise",
      "sunset": "sunset",
      "hourMeeting": "meeting time",
      "hour": "take-off time",
      "save": "save offsets",
      "save_hint": "The new offsets apply only to flights created from now on",
      "save_and_update_hours": "save offsets (and update flight hours)",
      "save_and_update_hours_hint": "all upcoming flights will be updated with the new offsets",
      "cancelReason": "cancel reason",
      "cancelReasons": "cancel reasons",
      "cancelReasonsHint": "if a flight is canceled, you can indicate the reason for cancellation",
      "cancelReasons_list_empty": "no cancel reasons found, add your first cancel reason",
      "new_cancelreason": "new cancel reason",
      "you_can_manage_all_cancelreasons_in_settings": "you can manage all cancel reasons in the settings",
      "cancelreason_validation": "cancel reason is required, min 3, max 50 characters and must be unique",
      "defaultPeriod": "default period",
      "defaultPeriodHint": "choose default period for creating new flights between morning or evening flights",
      "morning": "morning",
      "evening": "evening",
      "duplicateProtection": "flight duplicate protection",
      "duplicateProtectionHint": "Prevents a balloon from being scheduled for multiple flights simultaneously. You cannot add passengers to a flight if the same balloon already has another active flight at that time.",
      "duplicateProtection_enabled": "protection enabled",
      "duplicateProtection_disabled": "protection disabled"
    },
    "myflight": {
      "title": "Quick Release UP (Passengers App)",
      "autoConfirm": "automatically confirm the flight when it is requested via UP",
      "autoConfirmHint": "if this is not checked, the operator has to confirm the flight manually, when added via UP",
      "autoConfirmEmailTemplate": "confirmation email template",
      "autoConfirmEmailTemplateHint": "select an email template to automatically send to the passenger when the booking is confirmed",
      "noEmailTemplate": "no automatic email",
      "autoConfirmAPI": "automatically confirm the flight when it is requested via API",
      "autoConfirmAPIHint": "if this is not checked, the operator has to confirm the flight manually, when added via API (website)",
      "endOfSeason": "end of season",
      "endOfSeasonHint": "if this is checked, the passengers can no longer access their booking via UP",
      "flights": "Which flights can be booked via UP?",
      "ALL": "all flights, taking into account the tag restrictions",
      "REGIONAL": "only regional flights (flights in the same region as the booking)",
      "NONE": "no flights (passengers can only see their booking)",
      "parameters": "parameters",
      "branding": "branding",
      "logo": "logo",
      "logoHint": "upload your own logo here to show in the UP app",
      "drag_and_drop_file_here": "drag and drop jpg or png file here (max 500kB)",
      "colors": "colors",
      "colorsHint": "click on each color to adjust them to your own branding. You can choose a color from the palette of your logo in the pop-up",
      "example": "example",
      "reset": "reset colors",
      "save": "save colors and logo",
      "primary_background_color": "background color of the app",
      "secondary_background_color": "background color of the tiles",
      "primary_foreground_color": "color of the title and buttons",
      "secondary_foreground_color": "color of the informational text",
      "invalid_file_type_or_size": "invalid file type or size",
      "attachment_not_found": "Attachment file not found in storage — please remove and re-upload",
      "translations": "Translations",
      "change_translations": "Some texts can be customized",
      "click_button_to_change_translations": "Open the login screen of the UP-app for passengers with the button below. Login with a test booking or one of your existing bookings. Everywhere you see the following icon, you can adjust the translation.",
      "goto_api_settings": "You need an API key to be able to change translations. Go to the API settings to generate an API key.",
      "update_translations": "Update translations"
    },
    "cao": {
      "title": "CAO"
    },
    "sms": {
      "footerEnabled": "add footer to SMS",
      "footerEnabledHint": "if this is not checked, the footer will not be added to all invitation SMS"
    },
    "api": {
      "external_connection": "external connections",
      "external_connection_subtitle": "connect your website or other apps with Quick Release",
      "apiKey": "API Key",
      "generateApiKey": "Generate API Key",
      "noKeyMessage": "You don't have an API Key yet. Generate an API Key to gain access to the API.",
      "documentation": "Documentation",
      "documentationDescription": "Read the documentation for more information about the API.",
      "apiPlayground": "API Playground",
      "FlightAppDocumentation": "FlightApp documentation",
      "FlightAppHint": "Connect Quick Release with FlightApp’s recognized digital logbooks. Completed flights are automatically forwarded to FlightApp. Quick Release checks the validity of balloons and pilots with FlightApp.",
      "FlightAppApikeyNotValid": "Error: this FlightApp API key is not valid",
      "FlightAppAircraftNotValid": "Error: this FlightApp balloon was not found in the system. Please check the callsign.",
      "FlightAppPilotNotValid": "Error: this FlightApp pilot was not found in the system. Please check the email address.",
      "addFlightAppApiKey": "Add FlightApp API Key",
      "hideApiKey": "Hide API Key",
      "showApiKey": "Show API Key",
      "copyToClipboard": "Copy to clipboard",
      "newApiKey": "New API Key",
      "newApiKeyHint": "Enter the new API Key",
      "updating_keys": "the API keys are being updated"
    },
    "callback": {
      "title": "Callback URL",
      "subtitle": "Set a callback URL to receive notifications about booking events. The JSON payload contains the bookingId, flightId and the new status of the booking",
      "url": "Callback URL",
      "noUrlMessage": "No callback URL is set. Click the button below to set one.",
      "setUrl": "Set Callback URL",
      "saveUrl": "Save URL",
      "clearUrl": "Clear URL"
    },
    "security": {
      "title": "Security",
      "twoFA": "Two-factor authentication",
      "description": "Two-factor authentication adds an extra layer of security to your account. On untrusted devices, you will need to enter an additional 6-digit code that you receive via email.",
      "enableTwoFA": "Enable two-factor authentication",
      "enableTwoFAConfirm": "Enabling two-factor authentication will log you out immediately. Are you sure?",
      "mandatory": "Two-factor authentication is mandatory from January 1st, 2026"
    },
    "MESSAGING": {
      "ENABLED": "Messaging is enabled",
      "ENABLED_HINT": "Messages are sent via WhatsApp. When WhatsApp is unavailable, SMS fallback can be used.",
      "DISABLED": "Messaging is disabled",
      "DISABLED_HINT": "Contact Quick Release to enable messaging for your account.",
      "STATUS_CONNECTED": "WhatsApp connected",
      "STATUS_DISCONNECTED": "WhatsApp disconnected",
      "FALLBACK_WARNING": "WhatsApp is unavailable. Message will be sent via SMS (costs apply).",
      "RECONNECT_INSTRUCTIONS": "Please reconnect your WhatsApp device by scanning the QR code below."
    },
    "checkin_title": "Online Check-in",
    "checkin_mode_none": "no check-in",
    "checkin_mode_none_hint": "Check-in is not used.",
    "checkin_mode_pdf": "PDF check-in (manual)",
    "checkin_mode_pdf_hint": "Print the check-in sheet with your instructions; passengers sign on paper on flight day.",
    "checkin_mode_online": "PDF + online check-in",
    "checkin_mode_online_hint": "Passengers check in online before the flight via the booking app; the PDF sheet stays available. A notification channel (email or WhatsApp) is required.",
    "checkin_days_before": "Days before flight",
    "checkin_notification_channel": "Check-in notification channel",
    "checkin_instructions": "Check-in instructions (Markdown)",
    "checkin_save_instructions": "save check-in instructions",
    "checkin_load_default": "Load default instructions",
    "checkin_preview": "Preview",
    "checkin_schedule_explanation": "When check-in is enabled, passengers can check in online {{days}} days before their flight via the booking app. A notification is sent automatically every day at 10:00 (Belgian time) to confirmed bookings whose check-in window has opened.",
    "checkin_passenger_explanation": "This text is shown during online check-in (the passenger must confirm having read and understood it) and is printed on the PDF check-in sheet above the signatures. After online check-in, the booking becomes read-only in the app.",
    "checkin_channel_title": "Notification channel",
    "checkin_inapp_title": "check-in text",
    "checkin_email_preview_title": "Email notification",
    "checkin_email_preview_subject": "Subject",
    "checkin_whatsapp_preview_title": "WhatsApp notification",
    "checkin_email_template_hint": "This template can be customized in Settings → Email templates",
    "checkin_sms_template_hint": "This template can be customized in Settings → SMS/WhatsApp templates. The booking link is sent automatically as a separate message."
  },
  "REPORTS": {
    "flights": "flights",
    "bookings_open": "open bookings",
    "bookings": "new bookings",
    "vouchers": "vouchers",
    "payments": "payments",
    "sms": "MSG"
  },
  "MAIL": {
    "hide": "hide details",
    "show": "show details",
    "sent": "sent",
    "error": "sending failed"
  },
  "TENANT_ACTIONS": {
    "WHATSAPP_PAIR_REQUIRED": "WhatsApp reconnect required. Your messages will not be delivered until you scan the new QR code.",
    "WHATSAPP_SESSION_DISCONNECTED": "Your WhatsApp is disconnected. Reconnect to keep sending messages.",
    "cta": "Reconnect now",
    "dismiss": "Dismiss notification"
  },
  "SUBSCRIPTION": {
    "WA_CLOUD": {
            "billable": "WhatsApp Business paid (Meta)",
            "free": "WhatsApp Business free",
            "info": "Indicative — Meta bills WhatsApp Business messages directly on your own Meta account."
        },
    "sms_available": "available in subscription",
    "sms_sent": "SMS sent",
    "wa_sent": "WhatsApp sent",
    "recalculate": "recalculate",
    "pct_sms_used": "% of your SMS are used",
    "sms_info": "Contact us to order additional SMS as soon as you used 95% of available SMS in your subscription",
    "sms_warning": "You used 95% or more of your available SMS.",
    "LOW_SMS_BALANCE": "Low SMS balance - SMS fallback may fail when WhatsApp is unavailable.",
    "order_sms": "Order now new SMS",
    "sms_ignore_warning": "Hide notification about SMS usage",
    "pct_plan_used": "% of your seats are used",
    "plan_seats_used": "total balloon capacity",
    "plan_valid_until": "valid until",
    "plan_info": "Contact us to switch to a higher plan if the number of seats is too low or to renew your current subscription",
    "plan_expiring": "Your subscription will expire soon. Please renew to avoid interruption.",
    "plan_expiring_days": "Your subscription expires in {days} days. Please renew to avoid interruption.",
    "plan_expired_grace_days": "Your subscription has expired. Grace period ends in {days} days. Please renew immediately.",
    "plan_expired_since_days": "Your subscription has expired {days} days ago. Please renew to continue using Quick Release.",
    "plan_expired": "Your subscription has expired and the grace period has ended. Please renew to continue using Quick Release.",
    "plan_invalid_grace_days": "Your subscription is not valid - you have exceeded your capacity. Grace period ends in {days} days. Please renew immediately.",
    "plan_invalid_expired": "Your subscription is not valid - you have exceeded your capacity. Grace period has ended. Please renew immediately to continue using Quick Release.",
    "manage_subscription": "Manage subscription",
    "EXPIRED_MESSAGE": "Subscription expired. Renew to continue.",
    "blocked": "Subscription expired. Please renew to continue.",
    "custom_plan_title": "Custom Subscription Plan",
    "custom_plan_subtitle": "Manual renewal required",
    "custom_plan_message": "You have a custom subscription plan.",
    "custom_plan_contact": "Please contact the Quick Release team to request an adjustment or renewal."
  },
  "TAGS": {
    "delete": "remove tag",
    "enabled": "enabled",
    "enable_tag": "enable tag",
    "disabled": "disabled",
    "disable_tag": "disable tag",
    "save": "save tag",
    "new_tag": "create new tag",
    "tag_name": "tag name",
    "tag_type": "tag type",
    "select_tag_color": "select color",
    "color": "color",
    "tag_already_added": "tag already added",
    "edit": "edit tag",
    "flight_tags": "flight tags",
    "tags": "tags",
    "show_on_dashboard": "show on the dashboard",
    "allowedFlightTags": "allowed",
    "not_restricted": "all bookings allowed",
    "all_flights_allowed": "all flights allowed, except when specific booking tags are required",
    "onlyAllowedFlightTags": "only following booking tags are allowed",
    "no_bookings_allowed": "no bookings allowed"
  },
  "LOGBOOK": {
    "no_logbook_found": "no logbook found",
    "new_logs_since": "New logs since",
    "new_logs_since_beginning": "New logs since beginning",
    "total_new_logs": "Number of new logs:",
    "total_flight_time": "Total flight time:",
    "add": "Add",
    "log": "log",
    "logs": "logs",
    "refresh": "Refresh",
    "logs_in_logbook": "Logs in logbook",
    "total_logs": "Number of logs:",
    "latest_log": "Latest log:",
    "export": "Export",
    "send_to_flightapp": "Send to FlightApp",
    "delete_log": "Delete log",
    "confirm_delete_log": "Delete this log entry?",
    "confirm_delete_log_body": "This removes the log entry from the logbook. This action cannot be undone.",
    "start_date": "Start date",
    "initial_hours": "Pre-digital flight time",
    "initial_hours_hint": "Hours from paper logbook",
    "total_logged_time": "Logged flight time",
    "total_overall_time": "Total flight time",
    "settings": "Logbook settings",
    "setup_logbook": "Set up logbook",
    "start_date_hint": "Start of the digital logbook. Flights before this date are the paper era — enter their totals below; flights from this date on are counted from Quick Release. Older digital flights stay visible, greyed.",
    "before_start_date": "Before the start date — paper era, not counted in the totals",
    "hours": "hours",
    "minutes": "Minutes",
    "save_settings": "Save",
    "settings_saved": "Logbook settings saved",
    "initial_flights": "Flights before logbook",
    "initial_flights_short": "prior",
    "total_flights": "Total flights",
    "flights": "flights",
    "logged_short": "logged",
    "stats_since": "Statistics since",
    "logbook_title": "Logbook",
    "up_to_date": "Up to date",
    "pending_short": "to add",
    "from_system_pending": "from the system, not yet added",
    "logged_flights": "Logged flights"
  },
  "IMAGES": {
    "images": "images",
    "manage_images_for": "Manage images for",
    "upload_new_images": "Upload new images",
    "drag_and_drop_images_here": "Drag and drop images here",
    "max_files_reached": "Maximum number of images reached",
    "browse_for_images": "Browse for images",
    "supported_formats": "Supported formats",
    "max_size_5mb": "max size 5MB",
    "uploading": "Uploading",
    "image_library": "Image library",
    "no_images_found": "No images found",
    "delete_image": "Delete image",
    "hint": "The images you upload can be used when sending WhatsApp messages"
  },
  "INVOICE": {
    "LOADING": "Loading invoices...",
    "EMPTY_STATE": "No invoices found from the last 4 years",
    "TABLE": {
      "TITLE": "Invoices",
      "SUBTITLE": "Overview of your invoices",
      "INFO": "Here you can find all your invoices from the last 4 years. Click the download icon to download an invoice.",
      "INVOICE_CODE": "Invoice Code",
      "AMOUNT": "Amount",
      "DATE": "Date",
      "STATUS": "Status",
      "ACTIONS": "Actions",
      "DOWNLOAD_TOOLTIP": "Download Invoice"
    },
    "STATUS": {
      "PAID": "Paid",
      "SENT": "Sent",
      "REMINDED": "Reminded",
      "SUMMATION": "Summation",
      "EXPIRED": "Expired",
      "DRAFT": "Draft"
    }
  },
  "ORDER": {
    "LOADING": "Loading orders...",
    "EMPTY_STATE": "No orders found from the last 4 years",
    "TABLE": {
      "TITLE": "Orders",
      "SUBTITLE": "Overview of your orders",
      "INFO_PENDING": "You can add items to a pending order or delete it entirely.",
      "INFO_CONFIRMED_TITLE": "After confirmation:",
      "INFO_CONFIRMED_1": "You will receive an order confirmation by email",
      "INFO_CONFIRMED_2": "Your order will be processed and approved",
      "INFO_CONFIRMED_3": "You will receive the invoice by email",
      "INFO_CONFIRMED_4": "The new plan or credits will become active",
      "AMOUNT": "Amount",
      "DATE": "Date",
      "STATUS": "Status",
      "ITEMS": "Items",
      "PLAN": "Plan"
    },
    "STATUS": {
      "PENDING": "Pending",
      "CONFIRMED": "Processing",
      "APPROVED": "Approved",
      "CANCELLED": "Cancelled"
    },
    "ACTIONS": {
      "CONFIRM": "Confirm",
      "DELETE": "Delete",
      "APPROVE": "Approve",
      "CANCEL": "Cancel"
    }
  },
  "DEBTOR_VALIDATION": {
    "TITLE": "Billing Configuration Required",
    "SUBTITLE": "Your debtor details need to be configured",
    "MESSAGE": "To enable automatic renewal and upgrade functionality, please contact the Quick Release Team to configure your billing details."
  },
  "NEW_ORDER": {
    "TITLE": "New Order",
    "SUBTITLE": "Add items to your order",
    "INFO_SMS": "Order additional credit: 1 or more packages of 100 SMS or 1000 SMS.",
    "INFO_PLAN": "Automatically calculated based on your subscription status and balloon capacity. For upgrades, you only pay the difference.",
    "SUBTITLE_PLAN": "Automatically calculated based on your subscription status and balloon capacity. For upgrades, you only pay the difference.",
    "SUBTITLE_SMS": "Order additional credit: 1 or more packages of 100 SMS or 1000 SMS.",
    "PLAN": {
      "TITLE": "Plan Renewal/Upgrade",
      "EMPTY_MESSAGE": "No plans available",
      "NAME": "Plan",
      "MAX_SEATS": "Maximum seats"
    },
    "UNIT_PRICE": "Unit price",
    "QUANTITY": "Quantity",
    "ORDER_QUANTITY": "Quantity",
    "TOTAL": "Total",
    "CREDIT_AUTO_ADDED": "Credit automatically applied",
    "ALREADY_IN_ORDER": "Already in order",
    "ADD_TO_ORDER": "Add to Order",
    "SMS": {
      "TITLE": "SMS",
      "UNIT_PRICE": "Price per package",
      "PER_PACKAGE": "Per package",
      "ORDER_QUANTITY": "Number of packages",
      "TOTAL_SMS": "Total SMS"
    },
    "SUCCESS": "Item added to order",
    "ERROR_LINE": "Error adding order line",
    "ERROR_ORDER": "Error creating order",
    "SUBMITTING": "Placing orders...",
    "ORDER_PROCESSING": "An order is currently being processed. You cannot add new orders until it is approved or cancelled.",
    "CONFIRM_DIALOG": {
      "TITLE": "Confirm Order",
      "MESSAGE": "You are about to place an order.",
      "ORDER": "Order",
      "TOTAL": "Total",
      "VAT_EXCL": "VAT excl.",
      "VAT_21": "VAT 21%",
      "TOTAL_WITH_VAT": "Total incl. VAT",
      "VAT_REVERSE_CHARGE_NOTE": "Note: Reverse charge (VAT transfer) may apply to your order.",
      "VAT_REVERSE_CHARGE_SHORT": "(reverse charge may apply)",
      "NO_PAYMENT_OBLIGATION": "Once your order is approved, you will receive an invoice with payment obligation.",
      "AGREE_TERMS": "I agree to the",
      "TERMS_LINK": "general terms and conditions",
      "CONFIRM_ORDER": "Confirm Order"
    }
  },
  "CHECKIN": {
    "not_all_checked_in": "Not all passengers have checked in online",
    "proceed_warning": "{{count}} of {{total}} confirmed bookings have not completed online check-in. Do you want to proceed?",
    "opens_on": "Check-in opens on {{date}}",
    "checked_in": "checked in",
    "checkin_open": "Check-in open",
    "invite_sent_at": "check-in invite sent on {{date}}",
    "invite_not_sent": "no check-in invite sent yet",
    "send_invite": "send check-in invite",
    "invite_sent_success": "check-in invite sent",
    "send_invite_all": "send check-in invite to all open bookings",
    "send_invite_all_confirm": "Send a check-in invite to {{count}} bookings?",
    "invites_status_sent": "{{count}} invite(s) sent",
    "invites_status_planned": "{{count}} planned for {{date}}",
    "invite_planned_on": "check-in invite planned for {{date}}",
    "send_now": "send now",
    "preview_subject": "Your flight is ready for check-in – {{date}} – {{location}}",
    "preview_greeting": "Dear {{name}},",
    "preview_body": "Your balloon flight on <strong>{{date}}</strong> is now open for online check-in.",
    "preview_body2": "Please complete the check-in for your group ({{count}} passengers) before the flight date. During check-in you will be asked to review and confirm the safety instructions.",
    "preview_cta": "Check-in now",
    "preview_footer": "If you have any questions, please contact us.",
    "preview_wa_body": "Your balloon flight on **{{date}}** is now open for online check-in.",
    "preview_wa_body2": "Please complete the check-in for your group ({{count}} passengers) before the flight date.",
    "preview_wa_link": "Go directly to your personal booking page via this link!",
    "signature_sheet": "check-in signature sheet",
    "acknowledge": "I have read and understood the above information",
    "pdf_check_in": "CHECK-IN",
    "pdf_passenger_manifest": "Passenger manifest",
    "pdf_safety_briefing": "Safety briefing",
    "pdf_please_read": "Please read before boarding",
    "pdf_balloon_operator": "Hot air balloon operator",
    "pdf_acknowledgement": "ACKNOWLEDGEMENT",
    "pdf_passenger": "Passenger",
    "pdf_signature": "Signature",
    "pdf_morning_flight": "Morning flight",
    "pdf_evening_flight": "Evening flight",
    "pdf_date": "DATE",
    "pdf_balloon": "BALLOON",
    "pdf_pic": "PILOT IN COMMAND",
    "pdf_takeoff": "TAKEOFF",
    "pdf_pic_on_file": "PIC signature on file",
    "pdf_local_time": "Local time",
    "pdf_page": "Page {{current}} of {{total}}",
    "pdf_manifest_subtitle": "{{pax}} passengers · {{bookings}} bookings"
  },
  "NOTAM": {
    "title": "NOTAMs",
    "panel_title_combined": "weather and NOTAM",
    "tooltip_count": "{{count}} NOTAM(s) — open the flight for details",
    "none_known": "no relevant NOTAMs known",
    "none_known_short": "no NOTAMs known",
    "no_data": "no NOTAM data for this location",
    "stale": "NOTAM data could not be refreshed — last update {{time}}",
    "unavailable": "NOTAM data unavailable",
    "retry": "retry",
    "updated": "NOTAM data updated {{time}}",
    "disclaimer": "Decision support only — the official pre-flight briefing obligation remains with the pilot-in-command.",
    "horizon_hint": "NOTAMs are usually published close to the date, check again nearer the flight",
    "wide_area": "background notices (wide-area / AIP)",
    "show_text": "show raw NOTAM text",
    "hide_text": "hide raw NOTAM text",
    "period": "active period",
    "schedule": "daily schedule",
    "altitude_band": "altitude band",
    "connect_hint": "connect your Autorouter account to see NOTAM warnings",
    "reconnect_hint": "reconnect your Autorouter account to refresh NOTAM warnings",
    "connect_link": "open settings",
    "location_warning": "{{count}} NOTAM(s) at this location for the flight window",
    "CATEGORY": {
      "RESTRICTION": "airspace restriction",
      "WARNING": "navigation warning",
      "OBSTACLE": "obstacle",
      "AERODROME": "aerodrome",
      "UNCLASSIFIED": "unclassified"
    },
    "SETTINGS": {
      "title": "Airspace / NOTAM",
      "explanation": "NOTAM warnings on flights, the trajectory map and the dashboard require your own (free) autorouter.aero account. Quick Release fetches NOTAM data under your account's authorization.",
      "disclaimer": "NOTAM warnings are decision support only; the official pre-flight briefing obligation remains with the pilot-in-command.",
      "connect": "connect Autorouter account",
      "reconnect": "reconnect Autorouter account",
      "disconnect": "disconnect",
      "disconnect_confirm": "Disconnect your Autorouter account? The stored authorization and fetched NOTAM data will be removed.",
      "connected_as": "connected as",
      "connected_since": "since",
      "status_disconnected": "no Autorouter account connected",
      "reauth_warning": "the Autorouter authorization has expired or was revoked — reconnect to keep receiving NOTAM data",
      "connected_snack": "Autorouter account connected",
      "denied_snack": "Autorouter connection was declined",
      "error_snack": "Autorouter connection failed — please try again"
    }
  },
  "WEEKPLANNER": {
    "matrix": {
      "availability": "availability",
      "availability_tooltip": "Number of available pilots and crew — hover over the dots for names",
      "availability_empty": "No availability management yet. Let pilots and crew enter their own availability and you will see here who can fly each day.",
      "start_crew_login": "Start with crew login",
      "pilots_available": "available pilots",
      "crew_available": "available crew",
      "open_balloon": "Open the balloon detail",
      "seats": "seats",
      "add_balloon": "Add balloon",
      "no_balloons": "No balloons yet. Add your first balloon to plan flights.",
      "no_flights": "No flights this week.",
      "show_idle_balloons": "Balloons without flights ({{count}})",
      "hide_idle_balloons": "Hide balloons without flights",
      "add_flight_for": "Add flight —",
      "open_flight_tooltip": "Open the flight detail (or Ctrl/Cmd-click the cell)",
      "fly_ok": "Flyable",
      "fly_wind": "Wind warning",
      "fly_rain": "Not flyable — precipitation",
      "fly_nogo_wind": "Not flyable — wind"
    },
    "availability": {
      "yes": "available",
      "maybe": "maybe",
      "no": "not available",
      "unknown": "not filled in"
    },
    "create": {
      "new_location_option": "+ New location…",
      "no_locations": "You don't have any launch sites yet. Create the first one.",
      "new_location": "New location",
      "new_location_placeholder": "e.g. Bruges – Minnewater",
      "new_location_note": "GPS, permission and contact can be added later in the location detail.",
      "save_location": "Save location",
      "location_created": "Location {{name}} created.",
      "location_created_default": "Location {{name}} created — also your default location for weather and sun."
    },
    "planner": {
      "available_drag": "available — drag onto a flight",
      "no_people": "no pilots or crew yet",
      "assign_to": "Assign to…",
      "add_pilot": "Pilot",
      "add_crew": "Crew",
      "edit": "Edit the flight info",
      "edit_done": "Done editing",
      "publish": "Publish to crew",
      "unpublish": "Hide from crew",
      "mark_finished": "Mark as flown",
      "cancel": "Cancel flight",
      "restore": "Restore flight",
      "staffing": "Pilot, BE driver and crew",
      "published_chip": "crew",
      "published_tooltip": "Visible to the crew",
      "pilot": "Pilot",
      "driver": "BE driver",
      "crew": "Crew",
      "takeoff_temperature": "Take-off temperature",
      "trajectory": "trajectory",
      "lift_free": "{{kg}} kg free",
      "capacity_warning_title": "This exceeds the balloon capacity",
      "capacity_warning_body": "{{total}} passengers on {{capacity}} seats. Continue anyway?",
      "lift_warning_title": "Low lift on this flight",
      "lift_warning_body": "Only {{lift}} kg lift left. Assign anyway?",
      "person_already_assigned": "{{name}} is already on {{flight}} in this daypart.",
      "cancel_on_flight_page": "This flight has confirmed bookings: cancel it on the flight page so passengers can be informed.",
      "preferred_of": "regular crew of {{balloons}}",
      "propose_crew": "Propose regular crew",
      "propose_tooltip": "Put {{names}} on the flight of {{balloon}}",
      "apply_all": "Apply all"
    },
    "toast": {
      "flight_updated": "Flight updated — week data refreshed.",
      "booking_confirmed": "Booking confirmed — confirmation email sent.",
      "balloon_updated": "Balloon updated.",
      "save_failed": "Saving failed — please try again."
    },
    "pool": {
      "oldest_first": "oldest first",
      "clear_search": "clear",
      "new_booking": "New reservation",
      "filters": "filters",
      "count_tooltip": "number within the current search",
      "chip_to_confirm": "to confirm",
      "chip_unplanned": "not planned",
      "chip_voucher": "voucher expiring",
      "chip_open_amount": "amount due",
      "chip_favourite": "favourite",
      "clear_filters": "clear filters",
      "col_name": "Name",
      "col_contact": "Contact",
      "col_pax": "Pax · weight",
      "col_info": "Info",
      "col_comment": "Comment",
      "col_flight": "Flight",
      "col_actions": "Actions",
      "no_match": "No bookings for these filters.",
      "flight_tooltip": "Open the flight — dragging moves the booking",
      "unplanned": "not planned",
      "confirm": "Confirm",
      "load_more_n": "Load more ({{n}})"
    },
    "panel": {
      "kind_flight": "Flight",
      "kind_balloon": "Balloon",
      "kind_booking": "Reservation",
      "kind_person": "Person",
      "kind_location": "Location",
      "back": "Back to week planner",
      "close": "Close",
      "not_found": "Not found — it may have been removed.",
      "balloon": "Balloon",
      "status": "Status",
      "status_SCH": "scheduled",
      "status_REA": "ready for departure",
      "status_FIN": "flown",
      "status_CAN": "cancelled",
      "sun": "Sun",
      "sunrise": "sunrise",
      "sunset": "sunset",
      "yes": "yes",
      "no": "no",
      "crew_section": "Crew",
      "bookings": "Reservations",
      "no_bookings_on_flight": "No reservations on this flight yet.",
      "heading": "Expected direction",
      "distance": "Distance",
      "landing_zone": "Landing zone",
      "logbook": "Logbook",
      "takeoff_time": "Take-off time",
      "landing_time": "Landing time",
      "landing_place": "Landing place",
      "fuel": "Fuel (cylinders)",
      "open_page": "Open full page",
      "passenger_seats": "passenger seats",
      "passenger_seats_label": "Passenger seats",
      "basics": "Basics",
      "registration": "Registration",
      "to_complete": "still to complete",
      "envelope": "Envelope",
      "envelope_manufacturer": "Manufacturer",
      "envelope_volume": "Volume (m³)",
      "envelope_type": "Type",
      "basket_burner": "Basket & burner",
      "basket_type": "Basket type",
      "burner_type": "Burner",
      "cylinders": "Number of cylinders",
      "insurance": "Insurance",
      "insurance_company": "Company",
      "due_date": "Due date",
      "maintenance": "Maintenance",
      "last_inspection": "Last inspection",
      "envelope_hours": "Envelope flight hours",
      "flights_this_week": "Flights this week",
      "no_flights": "No flights planned.",
      "booking_detail": "Reservation detail",
      "contact": "Contact",
      "phone": "Phone",
      "email": "E-mail",
      "city": "City",
      "passengers": "Passengers",
      "preferred": "Preferred",
      "not_chosen": "not chosen yet",
      "not_planned": "Not planned.",
      "booking_status_OPEN": "open",
      "booking_status_ADDE": "added — to confirm",
      "booking_status_INVI": "invited",
      "booking_status_CONF": "confirmed",
      "booking_status_COMP": "completed",
      "booking_status_CANC": "cancelled",
      "region": "Region",
      "payment": "Payment",
      "to_pay": "To pay",
      "paid": "Paid",
      "voucher": "Gift voucher",
      "booking_code": "Code",
      "valid_until": "Valid until",
      "passenger_n": "Passenger {{n}}",
      "open_flight": "Open flight",
      "availability_this_week": "Availability this week",
      "profile": "Profile",
      "license_number": "Licence number",
      "license_expiry": "Licence valid until",
      "medical_until": "Medical until",
      "driver_licence_be": "BE driving licence",
      "launch_site": "Launch site",
      "default_for_weather": "default location for weather and sun",
      "default_location": "Default location",
      "no_flights_location": "No flights from this location.",
      "location_detail": "Location detail",
      "gps": "GPS coordinates",
      "address": "Address",
      "contact_person": "Contact person",
      "access_parking": "Access & parking",
      "preferred_crew": "Regular crew",
      "preferred_crew_note": "Based on earlier assignments.",
      "preferred_crew_of": "Regular crew of",
      "no_preferred_balloon": "No regular balloon yet — follows from the assignments."
    },
    "meteo": {
      "title": "Meteo",
      "no_default_location": "no default location",
      "follows_selection": "follows the selected day",
      "today_hint": "today — select a day in the matrix",
      "sun": "sun {{rise}} – {{set}}",
      "pill_good": "flyable",
      "pill_marginal": "doubtful",
      "pill_nogo": "not flyable",
      "pill_unknown": "no forecast",
      "pill_tooltip_good": "Flyable — wind within the limits",
      "pill_tooltip_marginal": "Doubtful — gusts above the limit",
      "pill_tooltip_nogo": "Not flyable — precipitation or wind beyond the limits",
      "pill_tooltip_unknown": "No forecast for this daypart",
      "no_forecast": "no forecast for this day",
      "row_hour": "Hour",
      "row_weather": "Weather",
      "row_temp": "Temp (°C)",
      "row_ground": "Ground",
      "row_wind": "Wind (kn)",
      "row_gust": "Gusts (kn)",
      "row_pressure": "Pressure (hPa)",
      "row_clouds": "Low clouds",
      "row_visibility": "Visibility (km)",
      "legend": "golden hours — flight windows around sunrise ({{rise}}) and sunset ({{set}}) · barbs: full feather = 10 kn, half = 5 kn",
      "updated": "updated"
    },
    "myWeek": {
      "title": "My week — {{name}}",
      "hint": "availability: click to switch · drag across days to copy",
      "my_availability": "my availability",
      "flights": "Flights",
      "click_to_fill": "click to fill in",
      "own_pilot": "My flight — I fly",
      "own_crew": "My flight — I ride along",
      "published": "Published flight",
      "join": "I’m coming",
      "saved": "Availability saved — the planner sees it right away.",
      "cleared": "Availability cleared.",
      "error_FLIGHT_HAS_CREW": "Someone else just joined this flight.",
      "error_FLIGHT_NOT_PUBLISHED": "This flight is no longer published.",
      "error_FLIGHT_NOT_SCHEDULED": "This flight is no longer planned.",
      "error_NOT_ON_FLIGHT": "You are no longer on this flight.",
      "error_ALREADY_PILOT": "You are already the pilot of this flight."
    },
    "theme": {
      "title": "Theme",
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    }
  }
}
